/* 2g (Ansen 2026-10-17): the Finish preview ID on a cart line, kept small: "(FP-XXXXXX)" + an (i) after the
   finish; pointing at either (or tapping) shows "Questions about this finishing? Call (833) 488-0005 and give this
   ID." The style is added once here, so a drawer drawn on the server (snippets/cart-drawer-item.liquid) gets it too. */
var AG_FP_ICO = '<svg aria-hidden="true" focusable="false" viewBox="0 0 256 256" fill="currentColor"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"/></svg>';
function AG_FP_TAG(id) {
  return ' <span class="ag-fp" tabindex="0">(' + id + ')<span class="ag-fp-i" aria-hidden="true">' + AG_FP_ICO + '</span>'
    + '<span class="ag-fp-tip" role="tooltip">' + 'Questions about this finishing? Call <a href="tel:+18334880005">(833) 488-0005</a> and give this ID.' + '</span></span>';
}
(function () {
  if (window.__agFp) return;
  window.__agFp = true;
  var s = document.createElement('style');
  s.id = 'ag-fp-css';
  s.textContent = ".ag-fp{position:relative;white-space:nowrap;color:#5d655f;cursor:help;outline-offset:2px;}.ag-fp-i{display:inline-flex;vertical-align:-2px;margin-left:3px;width:13px;height:13px;}.ag-fp-i svg{width:13px;height:13px;display:block;}.ag-fp-tip{position:absolute;right:0;bottom:calc(100% + 6px);width:230px;box-sizing:border-box;padding:8px 10px;background:#242B26;color:#fff;font-family:'Inter Tight',sans-serif;font-size:12px;font-weight:400;letter-spacing:0;text-transform:none;line-height:1.4;white-space:normal;text-align:left;box-shadow:0 4px 14px rgba(36,43,38,.18);opacity:0;visibility:hidden;transition:opacity .15s ease;z-index:30;}.ag-fp-tip::after{content:'';position:absolute;left:0;right:0;top:100%;height:8px;}.ag-fp-tip a{color:#fff !important;text-decoration:underline;}.ag-fp:hover .ag-fp-tip,.ag-fp:focus-within .ag-fp-tip,.ag-fp.is-open .ag-fp-tip{opacity:1;visibility:visible;}";
  (document.head || document.documentElement).appendChild(s);
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.ag-fp') : null;
    if (t && e.target.closest('a')) return;
    document.querySelectorAll('.ag-fp.is-open').forEach(function (x) { if (x !== t) x.classList.remove('is-open'); });
    if (t) t.classList.toggle('is-open');
  });
})();

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    console.log('CartDrawer constructor called');

    this.drawer = this; // The custom element itself is the drawer
    this.overlay = document.querySelector('#cart-drawer-overlay');
    this.openButton = document.querySelector('[data-cart-drawer-toggle]');
    this.closeButton = this.querySelector('.cart-drawer__close');
    this.cartItems = this.querySelector('#cart-drawer-items') || this.querySelector('.cart-drawer__items');
    this.cartForm = this.querySelector('.cart-drawer__form');
    this.cartNote = this.querySelector('#cart-drawer-note');
    this.lastCartNote = ''; // Track the last saved cart note

    console.log('CartDrawer elements found:', {
      drawer: this.drawer,
      overlay: this.overlay,
      openButton: this.openButton,
      closeButton: this.closeButton,
      cartItems: this.cartItems
    });

    this._agAsset();
    this.bindEvents();
    this.setupQuantityControls();
    this.setupRemoveButtons();
    
    // Initialize cart totals on page load
    this.initializeCart();
  }

  async initializeCart() {
    try {
      console.log('Initializing cart...');
      const cart = await this.refreshCart();
      
      if (cart && cart.items.length === 0) {
        // Hide checkout buttons if cart is empty on initial load
        this.hideDynamicCheckoutButtons();
      } else if (cart && cart.items.length > 0) {
        // Cart has items, ensure checkout buttons are initialized
        console.log('Cart has items on load, initializing checkout buttons...');
        this.showDynamicCheckoutButtons();
        
        // Initialize payment buttons after a short delay to ensure DOM is ready
        setTimeout(() => {
          this.initializePaymentButtons();
        }, 300);
      }
    } catch (error) {
      console.error('Error initializing cart:', error);
    }
  }

  bindEvents() {
    // Open cart drawer
    if (this.openButton) {
      this.openButton.addEventListener('click', this.open.bind(this));
    }

    // Close cart drawer
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        console.log('Overlay clicked, closing cart drawer');
        this.close();
      });
    }

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        console.log('Escape key pressed, closing cart drawer');
        this.close();
      }
    });

    // Close on click outside cart drawer
    document.addEventListener('click', (e) => {
      if (this.isOpen()) {
        // a click made by a script is not the client clicking away: while a product page starts up,
        // dawn-variant-selector.js clicks the gallery thumbnail (jQuery .trigger), which closed a drawer
        // opened in those seconds (2026-10-15 v3.2 QC). A real tap outside is trusted and still closes it.
        if (!e.isTrusted) return;
        // a target no longer in the document was inside a block the click itself repainted: not an outside click
        if (!e.target || !e.target.isConnected) return;
        // Check if click is outside the cart drawer
        if (!this.drawer.contains(e.target) && !e.target.closest('[data-cart-drawer-toggle]')) {
          console.log('Clicked outside cart drawer, closing');
          this.close();
        }
      }
    });

    // Handle form submission
    if (this.cartForm) {
      this.cartForm.addEventListener('submit', this.handleFormSubmit.bind(this));
    }
  }

  // setupQuantityControls() {
  //   const quantityButtons = this.querySelectorAll('.quantity__button');
    
  //   quantityButtons.forEach(button => {
  //     button.addEventListener('click', (e) => {
  //       e.preventDefault();
  //       alert('hiiiii');
  //       const input = button.parentElement.querySelector('.quantity__input');
  //       const currentValue = parseInt(input.value);
  //       const isIncrease = button.classList.contains('quantity__button--plus');
        
  //       let newValue = isIncrease ? currentValue + 1 : currentValue - 1;
  //       newValue = Math.max(0, newValue);
        
  //       input.value = newValue;
  //       input.dispatchEvent(new Event('change', { bubbles: true }));
  //     });
  //   });

  //   // Handle quantity input changes
  //   const quantityInputs = this.querySelectorAll('.quantity__input');
  //   quantityInputs.forEach(input => {
  //     input.addEventListener('change', this.updateQuantity.bind(this));
  //   });
  // }



setupQuantityControls() {
  const quantityButtons = this.querySelectorAll('.quantity__button');

  quantityButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();


      const quantityWrapper = button.closest('.quantity');

      if (quantityWrapper.classList.contains('is-locked')) return;


      quantityWrapper.classList.add('is-locked');


      const input = button.parentElement.querySelector('.quantity__input');
      const currentValue = parseInt(input.value, 10) || 0;
      const isIncrease = button.classList.contains('quantity__button--plus');

      let newValue = isIncrease ? currentValue + 1 : currentValue - 1;
      newValue = Math.max(0, newValue);

      input.value = newValue;

    
      input.dispatchEvent(new Event('change', { bubbles: true }));

    });
  });

  // Handle quantity input changes
  const quantityInputs = this.querySelectorAll('.quantity__input');
  quantityInputs.forEach(input => {
    input.addEventListener('change', this.updateQuantity.bind(this));
  });
}


  setupRemoveButtons() {
    const removeButtons = this.querySelectorAll('.cart-drawer__item-remove-button');
    
    removeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const cartItem = button.closest('.cart-drawer__item');
        const input = cartItem.querySelector('.quantity__input');
        input.value = 0;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  async updateQuantity(event) {
    const input = event.target;
    const quantity = parseInt(input.value);
    const index = input.dataset.index;

    console.log('Updating quantity:', { index, quantity });
    // a11y 1c N5: name the line now; the refresh below re-renders it
    const agItem = input.closest('.cart-drawer__item');
    const agTitleEl = agItem && agItem.querySelector('.cart-drawer__item-title');
    const agTitle = agTitleEl ? agTitleEl.textContent.replace(/\s+/g, ' ').trim() : 'Item';
    const agFoc = document.activeElement;
    const agFocSel = agFoc && agItem && agItem.contains(agFoc)
      ? (agFoc.classList.contains('quantity__button--plus') ? '.quantity__button--plus' : agFoc.classList.contains('quantity__button--minus') ? '.quantity__button--minus' : agFoc.classList.contains('quantity__input') ? '.quantity__input' : null)
      : null;

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: index,
          quantity: quantity
        })
      });

      if (response.ok) {
        const updatedCart = await this.refreshCart();
        console.log('Cart updated after quantity change:', updatedCart?.items?.length || 0, 'items');

        // If cart is now empty, ensure we show empty state
        if (updatedCart && updatedCart.items.length === 0) {
          console.log('Cart is now empty, forcing empty state');
          this.showEmptyState();
        }

        // a11y 1c N5 (2026-10-21): say what changed and what is left (a removal used to happen in silence), and keep
        // focus inside the drawer when the control that had it was re-rendered away
        if (window.agAnnounce) {
          const agCountEl = this.querySelector('[data-cart-drawer-count]');
          const agLeft = agCountEl ? agCountEl.textContent.replace(/\s+/g, ' ').trim() : '';
          window.agAnnounce((quantity === 0 ? 'Removed ' + agTitle + '.' : agTitle + ': quantity ' + quantity + '.') + (agLeft ? ' Your cart: ' + agLeft + '.' : ''));
        }
        if (this.drawer.classList.contains('cart-drawer--open') && (!document.activeElement || document.activeElement === document.body || !this.contains(document.activeElement))) {
          const agIn = quantity > 0 && agFocSel ? this.querySelector('.quantity__input[data-index="' + index + '"]') : null;
          const agBack = agIn && agIn.closest('.cart-drawer__item') ? agIn.closest('.cart-drawer__item').querySelector(agFocSel) : null;
          (agBack || this.drawer).focus({ preventScroll: true });   // the same stepper control, else the drawer itself
        }
      } else {
        throw new Error('Failed to update cart');
      }
    } catch (error) {
      console.error('Error updating cart:', error);
      // Revert the input value
      input.value = input.dataset.originalValue || 1;
    }
  }

  async handleFormSubmit(event) {
    event.preventDefault();
    
    console.log('Form submitted, saving cart notes before checkout');
    
    // Get the cart note
    const cartNote = event.target.querySelector('#cart-drawer-note');
    const noteValue = cartNote ? cartNote.value.trim() : '';
    
    console.log('Cart note value:', noteValue);
    
    try {
      // Save cart note if it has changed
      if (noteValue !== this.lastCartNote) {
        console.log('Saving cart note...');
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            note: noteValue
          })
        });
        
        if (response.ok) {
          console.log('Cart note saved successfully');
          this.lastCartNote = noteValue;
        } else {
          console.error('Failed to save cart note:', response.status);
        }
      }
      
      // Proceed to checkout
      console.log('Redirecting to checkout...');
      window.location.href = '/checkout';
      
    } catch (error) {
      console.error('Error saving cart note:', error);
      // Still proceed to checkout even if note saving fails
      window.location.href = '/checkout';
    }
  }

  async handleCartNoteChange(event) {
    const noteValue = event.target.value.trim();
    
    // Debounce the save operation to avoid too many API calls
    clearTimeout(this.noteSaveTimeout);
    this.noteSaveTimeout = setTimeout(async () => {
      if (noteValue !== this.lastCartNote) {
        console.log('Auto-saving cart note:', noteValue);
        try {
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              note: noteValue
            })
          });
          
          if (response.ok) {
            console.log('Cart note auto-saved successfully');
            this.lastCartNote = noteValue;
          } else {
            console.error('Failed to auto-save cart note:', response.status);
          }
        } catch (error) {
          console.error('Error auto-saving cart note:', error);
        }
      }
    }, 1000); // Save after 1 second of inactivity
  }

  async refreshCart() {
    try {
      console.log('Refreshing cart...');
      
      // Fetch updated cart data
      const response = await fetch('/cart.js', {
        cache: 'no-store',
        headers: { 'Cache-Control': 'no-cache' }
      });
      if (response.ok) {
        const cart = await response.json();
        await Promise.race([this._agAsset(), new Promise((r) => setTimeout(r, 1500))]);
        // Track the current cart note
        this.lastCartNote = cart.note || '';
        
        // Update cart display and count
        this._agwgWarm(cart);
        this.updateCartDisplay(cart);
        this.updateCartCount(cart);
        
        console.log('Cart refresh completed');
        return cart; // Return the cart data for promise chaining
      } else {
        throw new Error(`Failed to fetch cart: ${response.status}`);
      }
    } catch (error) {
      console.error('Error refreshing cart:', error);
      throw error; // Re-throw for promise rejection
    }
  }

  /* Higher-tier nudge for trade carts (Datch 2026-10-06): the partner's tag sets the
     rate (cumulative T12M), so a single order crossing a published volume threshold
     stays at the tagged rate. When the PRE-discount total crosses a tier above the
     current rate, say so and point at the rep. Trade applications only. */
  /* One row per discount (Datch 2026-10-12): the cart-level applications (order codes, the trade rate) plus the
     line-level applications (set pricing, product codes) summed by title from the lines' allocations. When the rows do
     not add up to total_discount (an allocation listed twice, a shape /cart.js changes), one row carries the total. */
  _agDiscountRows(cart) {
    const rows = [];
    const add = (title, amount) => { const t = title || 'Discount'; const r = rows.find((x) => x.title === t); if (r) r.amount += amount; else rows.push({ title: t, amount }); };
    (cart.cart_level_discount_applications || []).forEach((a) => add(a.title, Math.round(+a.total_allocated_amount || 0)));
    (cart.items || []).forEach((it) => (it.line_level_discount_allocations || []).forEach((al) => add(al.discount_application && al.discount_application.title, Math.round(+al.amount || 0))));
    const sum = rows.reduce((s, r) => s + r.amount, 0);
    if (!rows.length || sum !== cart.total_discount) return [{ title: rows.length === 1 ? rows[0].title : 'Discount', amount: cart.total_discount }];
    return rows;
  }

  agTierNote(cart) {
    const app = (cart.cart_level_discount_applications || [])[0];
    if (!this.agUniformRate || !app || !/^Trade partner rate/.test(app.title || '')) return '';
    // the pre-discount total: total_price + total_discount (original_total_price misreports order-class discounts, 2026-10-06)
    const original = cart.total_price + cart.total_discount;
    let note = '';
    if (original > 15000000 && this.agUniformRate < 99) {
      note = 'Orders above <span class="num">$150,000</span> are priced per project. Contact <a href="mailto:support@arcgrove.com">your trade rep</a> for a direct quote.';
    } else if (original > 7500000 && this.agUniformRate < 15) {
      note = 'Orders over <span class="num">$75,000</span> qualify for the <span class="num">15%</span> rate. Contact <a href="mailto:support@arcgrove.com">your trade rep</a> for a direct quote.';
    } else if (original > 2500000 && this.agUniformRate < 10) {
      note = 'Orders over <span class="num">$25,000</span> qualify for the <span class="num">10%</span> rate. Contact <a href="mailto:support@arcgrove.com">your trade rep</a> for a direct quote.';
    }
    return note ? `<p class="cart-drawer__tier-note">${note}</p>` : '';
  }

  updateCartDisplay(cart) {
    /* Uniform percentage-off-order detection (trade rates): exactly one cart-level
       percentage application across all items -> per-line figures derive exactly as
       unit x rate. Anything else (codes, mixed apps) -> 0, lines render untouched
       and only the totals discount row shows. (Datch 2026-10-06) */
    const agApps = cart.cart_level_discount_applications || [];
    this.agUniformRate = (
      cart.total_discount > 0 &&
      agApps.length === 1 &&
      agApps[0].value_type === 'percentage' &&
      agApps[0].target_selection === 'all'
    ) ? parseFloat(agApps[0].value) || 0 : 0;

    console.log('Updating cart display with:', cart.items.length, 'items');
    
    if (cart.items.length === 0) {
      console.log('Cart is empty, showing empty state');
      this.showEmptyState();
      // Hide dynamic checkout buttons globally when cart is empty
      this.hideDynamicCheckoutButtons();
    } else {
      console.log('Cart has items, showing cart items');
      this.showCartItems(cart);
      // Ensure totals are updated after showing items
      this.updateTotals(cart);
      // Show dynamic checkout buttons when cart has items
      this.showDynamicCheckoutButtons();
    }
  }

  hideDynamicCheckoutButtons() {
    // Hide all dynamic checkout button wrappers globally
    const allCheckoutWrappers = document.querySelectorAll('.shop-pay-button-wrapper, .dynamic-checkout__content, .cart-drawer__dynamic-checkout');
    allCheckoutWrappers.forEach(wrapper => {
      wrapper.style.display = 'none';
      
      // Hide shopify-accelerated-checkout-cart components
      const checkoutCart = wrapper.querySelector('shopify-accelerated-checkout-cart');
      if (checkoutCart) {
        checkoutCart.style.display = 'none';
      }
      
      // Hide skeleton loaders
      const skeletons = wrapper.querySelectorAll('.wallet-cart-button__skeleton, .shopify-payment-button__skeleton');
      skeletons.forEach(skeleton => {
        skeleton.style.display = 'none';
      });
    });
    
    console.log('Hid all dynamic checkout buttons (cart is empty)');
  }

  showDynamicCheckoutButtons() {
    // Show dynamic checkout buttons in cart drawer only
    const cartDrawerWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
    if (cartDrawerWrapper) {
      cartDrawerWrapper.style.display = 'block';
      cartDrawerWrapper.style.opacity = '1';
      
      // Show shopify-accelerated-checkout-cart component
      const checkoutCart = cartDrawerWrapper.querySelector('shopify-accelerated-checkout-cart');
      if (checkoutCart) {
        checkoutCart.style.display = 'block';
        
        // Hide skeleton loaders if they exist
        const skeletons = checkoutCart.querySelectorAll('.wallet-cart-button__skeleton, .wallet-cart-grid--skeleton');
        skeletons.forEach(skeleton => {
          skeleton.style.display = 'none';
        });
      }
      
      // Initialize payment buttons if Shopify.PaymentButton is available
      if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) {
        try {
          Shopify.PaymentButton.init();
          console.log('Payment buttons initialized');
        } catch (error) {
          console.error('Error initializing payment buttons:', error);
        }
      }
    }
    
    console.log('Showing dynamic checkout buttons (cart has items)');
  }

  showEmptyState() {
    this.drawer.classList.add('cart-drawer--empty');
    const cartContent = this.querySelector('.cart-drawer__content');
    if (!cartContent) return;
    cartContent.innerHTML = `
      <div class="cart-drawer__empty">
        <div class="cart-drawer__empty-content">
          <h3 class="cart-drawer__empty-heading">Your cart is empty. Shop desks to get started.</h3>
          <a href="/collections/executive-desks" class="button button--primary">Shop desks</a>
        </div>
      </div>`;
  }

  /* Redesign 2026-10-11 (Datch: option 4 "Receipt" + option 3's note link and white-glove line; spec in the workspace,
     design-handoff/cart-drawer-redesign/spec.md). The drawer is rebuilt here after every cart change and must agree
     with snippets/cart-drawer.liquid, which renders it on page load: same classes, same order, same copy. */
  showCartItems(cart) {
    this.drawer.classList.remove('cart-drawer--empty');
    const cartContent = this.querySelector('.cart-drawer__content');
    if (!cartContent) return;
    const esc = this._agEsc;
    cartContent.innerHTML = '';

    const cartForm = document.createElement('form');
    cartForm.className = 'cart-drawer__form';
    cartForm.setAttribute('action', '/cart');
    cartForm.setAttribute('method', 'post');
    cartForm.setAttribute('novalidate', '');

    const cartItemsContainer = document.createElement('div');
    cartItemsContainer.id = 'cart-drawer-items';
    cartItemsContainer.className = 'cart-drawer__items';
    // the newest set member's set renders as ONE group (Datch 2026-10-12 16:40): every cart line of that set, in cart
    // order, where its newest line sits, then the matching-set card (_agSetRow appends it as the group's last child); a
    // thin bracket spans the group. The other lines follow in cart order. Line indexes stay the real cart positions.
    // Mirrors snippets/cart-drawer.liquid.
    const setOf = (it) => { const p = this._agSets && this._agSets.products && this._agSets.products[it.handle]; return p && p.set ? p.set : ''; };
    // EVERY set with two or more lines in the cart renders as one group under its bracket (Datch 2026-10-12 18:40),
    // where its oldest line falls; a set with one line stays a plain line (its card, if any, sits inside that line)
    // round 4 (Ansen 2026-10-17, board 10B): a set in two finishes is two groups, each under its own bracket. The
    // finish = the custom finish codes without the side, else the stock finish option. The set card and the set
    // saving still count the whole set (only the look splits).
    const finOf = (it) => this._agFinKey(it);
    const keyOf = (it) => { const s = setOf(it); return s ? s + '|' + finOf(it) : ''; };
    const counts = {}; cart.items.forEach((it) => { const k = keyOf(it); if (k) counts[k] = (counts[k] || 0) + 1; });
    // display order = oldest line first, newest last (Datch 2026-10-12 17:00); indexes stay the real cart positions
    const display = cart.items.map((item, index) => ({ item, index })).reverse();
    let itemsHtml = ''; const opened = {};
    display.forEach(({ item, index }) => {
      const s = setOf(item), k = keyOf(item);
      if (k && counts[k] >= 2) {
        if (!opened[k]) { opened[k] = true; itemsHtml += `<div class="cart-drawer__set-group" data-ag-set-group="${esc(s)}" data-ag-set-key="${esc(k)}">` + display.filter((d) => keyOf(d.item) === k).map((d) => this.renderCartItem(d.item, d.index + 1)).join('') + '</div>'; }
      } else itemsHtml += this.renderCartItem(item, index + 1);
    });
    cartItemsContainer.innerHTML = itemsHtml;
    if (window.AGSR && typeof window.AGSR.fill === 'function') window.AGSR.fill(cartItemsContainer);   // round 4: finish dots

    const money = (c) => this.formatMoney(c).replace(/\.00$/, '');
    // totals (Datch 2026-10-12): Shipping, one row per discount, the trade tier note where it applies, then the final
    // row ("Subtotal", or "Trade Partner Price" on a trade cart); no list-price subtotal row (the lines carry the struck
    // list prices). Mirrors snippets/cart-drawer.liquid.
    const discountRows = cart.total_discount > 0 ? this._agDiscountRows(cart) : [];
    const isTrade = discountRows.some((r) => /^Trade partner rate/.test(r.title || ''));
    const finalLabel = cart.total_discount > 0 && isTrade ? 'Trade Partner Price' : 'Subtotal';
    const footer = document.createElement('div');
    footer.className = 'cart-drawer__footer';
    footer.innerHTML = `
      <div class="cart-drawer__note" data-cart-note>
        <button type="button" class="cart-drawer__link" data-cart-note-toggle aria-expanded="false" aria-controls="cart-drawer-note">${cart.note ? 'Edit your note' : 'Add a note to your order'}</button>
        <span class="cart-drawer__note-preview">${esc(cart.note || '')}</span>
        <div class="cart-drawer__note-field">
          <label for="cart-drawer-note">Order note</label>
          <textarea class="cart-drawer__note-textarea" name="note" id="cart-drawer-note" placeholder="Anything we should know about this order">${esc(cart.note || '')}</textarea>
        </div>
      </div>
      <!-- agwg start: white glove callout, rebuilt with the note on every open -->
      <a class="agwg-cartline" href="/pages/white-glove-delivery" data-agwg-state="unknown">
        <span class="agwg-cartline-label">WHITE GLOVE DELIVERY AVAILABLE</span>
        <span class="agwg-cartline-tail">Learn more</span>
        <span class="agwg-cartline-sub">Your order is delivered to our white-glove partner, who then delivers and installs.</span>
      </a>
      <!-- agwg end -->
      <div class="cart-drawer__totals">
        <div class="cart-drawer__ship"><span class="cart-drawer__ship-label">Shipping</span><span class="cart-drawer__ship-value">Free</span></div>
        ${discountRows.map((r) => `<div class="cart-drawer__discount"><span class="cart-drawer__discount-label">${esc(r.title)}</span><span class="cart-drawer__discount-amount">-${money(r.amount)}</span></div>`).join('')}
        ${this.agTierNote(cart)}
        <div class="cart-drawer__subtotal">
          <span class="cart-drawer__subtotal-label">${finalLabel}</span>
          <span class="cart-drawer__subtotal-price">${money(cart.total_price)}</span>
        </div>
        <div class="cart-drawer__taxes"><p class="cart-drawer__taxes-note">Taxes calculated at checkout.</p></div>
      </div>
    `;
    this._agwgStamp(footer, cart);

    // agcd-fix r3: the checkout block is the form's LAST child so its sticky containing block spans the scroll content
    const agCheckoutBlock = document.createElement('div');
    agCheckoutBlock.className = 'cart-drawer__checkout';
    agCheckoutBlock.innerHTML = `
      <button type="submit" class="cart-drawer__checkout-button button button--primary" name="add" aria-haspopup="dialog">Checkout &middot; ${money(cart.total_price)}</button>
      <p class="cart-drawer__checkout-note">Shop Pay and Google Pay at checkout</p>
    `;

    cartForm.appendChild(cartItemsContainer);
    cartForm.appendChild(footer);
    cartForm.appendChild(agCheckoutBlock);
    cartContent.appendChild(cartForm);

    this.cartForm = cartForm;
    this.cartItems = cartItemsContainer;
    this.cartForm.addEventListener('submit', this.handleFormSubmit.bind(this));
    const cartNoteTextarea = footer.querySelector('#cart-drawer-note');
    if (cartNoteTextarea) cartNoteTextarea.addEventListener('input', this.handleCartNoteChange.bind(this));
    this._agBindNote(footer);
    this.setupQuantityControls();
    this.setupRemoveButtons();
    this._agSetRow(cart);
    this._agChairRow(cart);   // photo picks + add-ons (2026-10-17): the chair in these photos
    this._agLinePreviews(cart);
  }

  // set custom finishes, round 2 (Ansen 2026-10-16: "carry the flashing and the progress bar into it, even after they
  // click Add"): a custom-finishing line added while its preview is still being made carries the url that preview WILL
  // have (_preview; ag-set-renders.js predict). Until that picture exists the line shows its stock picture fading in and
  // out over a filling bar, then the preview swaps in. A preview that is already there swaps in at once, with no fade.
  // round 5 (Ansen 2026-10-16: "if we're clicking on a product from a custom finish, pre-enter that custom finish"): a
  // custom-finish line's link opens its product page in that finish, at its size (agcf.js reads agf/agl; the lead is
  // the line's own product, whose preview of the pair the line carries)
  _agCarryUrl(item) {
    const url = (item && item.url) || '';
    const fc = String(((item && item.properties) || {})._finish_codes || '');
    const p = (/(?:^|;)\s*P=([^;]+)/.exec(fc) || [])[1];
    if (!url || !p) return url;
    const a = (/(?:^|;)\s*A=([^;]+)/.exec(fc) || [])[1] || 'none';
    const sc = (/(?:^|;)\s*S=([^;]+)/.exec(fc) || [])[1] || '';
    const side = sc === 'L' ? 'left' : sc === 'R' ? 'right' : 'base';
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'agf=' + encodeURIComponent(p.trim() + '.' + a.trim() + '.' + side)
      + '&agl=' + encodeURIComponent(item.handle || '');
  }

  // round 4 (Ansen 2026-10-17, canvas board 12A, "auto, free"): a custom-finish line added with no preview starts that
  // preview here in the cart, by itself. The request carries &cart=1: a free render (not one of the shopper's 10 a day;
  // the store's daily cap and the service's own cart caps still apply). Same look as a line added mid-render (Ansen:
  // "just the current animation", no words): the picture fades in and out over a filling bar until it lands, then
  // swaps in; the set card gets another chance at its pieces (they need the lead's preview). A refusal or a failure
  // keeps the stand-in quietly, and is not asked again on this page.
  _agCartRender(row, it, img) {
    const SR = window.AGSR;
    const p = it.properties || {};
    if (!SR || typeof SR.want !== 'function' || typeof SR.codes !== 'function') return;
    const c = SR.codes(String(p._finish_codes));
    if (!c || !c.p) return;
    const sc = (/(?:^|;)\s*S=([^;]+)/.exec(String(p._finish_codes)) || [])[1] || '';
    const side = sc === 'L' ? 'left' : sc === 'R' ? 'right' : 'base';
    const so = (it.options_with_values || []).find((o) => /size|width|length/i.test(o.name));
    const o = { handle: it.handle, p: c.p, a: c.a || '', side, size: so ? so.value : '', cart: true };
    const show = (u) => { img.setAttribute('src', u); img.classList.remove('cart-drawer__item-image-img--flip'); };
    const known = SR.known(o);
    if (known) { show(known); return; }
    const key = typeof SR.keyOf === 'function' ? SR.keyOf(o) : it.handle + '__' + c.p;
    const tried = (this._agCartTried = this._agCartTried || {});
    if (tried[key] === 'failed') return;
    const box = row.querySelector('.cart-drawer__item-image');
    if (box && !box.querySelector('.agsr-line-bar')) box.insertAdjacentHTML('beforeend', '<span class="agsr-line-bar" aria-hidden="true"><span></span></span>');
    const sp = box && box.querySelector('.agsr-line-bar > span');
    if (sp && typeof SR.elapsed === 'function') sp.style.animationDelay = (-SR.elapsed(key) / 1000).toFixed(2) + 's';
    row.classList.add('is-agsr-rendering');
    tried[key] = 'running';
    SR.want(o).then((u) => {
      tried[key] = u ? 'done' : 'failed';
      if (!row.isConnected) return;
      row.classList.remove('is-agsr-rendering');
      const bar = box && box.querySelector('.agsr-line-bar');
      if (bar) bar.remove();
      if (u) {
        show(u);
        // the set pieces' previews need the lead's: let the set card ask again now
        this._agSrFail = {};
        if (this._agChairCart) this._agSetRow(this._agChairCart);
      }
    });
  }

  _agLinePreviews(cart) {
    const SR = window.AGSR;
    if (!SR || typeof SR.waitImage !== 'function' || !cart || !cart.items) return;
    this.querySelectorAll('#cart-drawer-items .cart-drawer__item').forEach((row) => {
      const input = row.querySelector('.quantity__input[data-index]');
      const idx = input ? parseInt(input.getAttribute('data-index'), 10) : 0;
      const it = idx ? cart.items[idx - 1] : null;
      const p = (it && it.properties) || {};
      const pv = p['Custom Finishing'] ? String(p._preview || '') : '';
      const img = row.querySelector('.cart-drawer__item-image-img');
      // round 4 (board 12A): a custom-finish line with no preview starts its own, here in the cart
      if (!pv && img && p['Custom Finishing'] && p._finish_codes) { this._agCartRender(row, it, img); return; }
      if (!pv || !/^https?:/.test(pv) || !img) return;
      const show = (u) => { if (img.getAttribute('src') !== u) img.setAttribute('src', u); img.classList.remove('cart-drawer__item-image-img--flip'); };
      if (SR.isReady(pv)) { show(pv); return; }
      // the fade waits a moment: a preview the browser already has lands first, with no flicker
      const t = setTimeout(() => {
        if (!row.isConnected) return;
        const box = row.querySelector('.cart-drawer__item-image');
        if (box && !box.querySelector('.agsr-line-bar')) box.insertAdjacentHTML('beforeend', '<span class="agsr-line-bar" aria-hidden="true"><span></span></span>');
        // round 3: the bar picks up where this preview's render really is, so closing and reopening the cart (every
        // redraw makes a new bar) never starts it over
        const sp = box && box.querySelector('.agsr-line-bar > span');
        if (sp && typeof SR.elapsed === 'function') sp.style.animationDelay = (-SR.elapsed(pv) / 1000).toFixed(2) + 's';
        row.classList.add('is-agsr-rendering');
      }, 400);
      SR.waitImage(pv).then((u) => {
        clearTimeout(t);
        row.classList.remove('is-agsr-rendering');
        if (u && row.isConnected) show(u);
      });
    });
  }

  async loadDynamicCheckoutButtons() {
    const paymentWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
    if (!paymentWrapper) {
      console.log('No payment wrapper found, skipping checkout buttons load');
      return;
    }

    // agcd-fix: reuse — if the wallet component is already present (preserved across rebuilds
    // or injected earlier) never re-fetch; re-hydration IS the late pop-in this fix removes.
    if (paymentWrapper.querySelector('shopify-accelerated-checkout-cart')) {
      paymentWrapper.style.display = '';
      return;
    }
    // agcd-fix: single-flight — the /cart scrape is a ~547KB document; concurrent rebuild
    // calls share one in-flight fetch instead of firing it repeatedly.
    if (this._agWalletFetch) {
      return this._agWalletFetch;
    }
    this._agWalletFetch = this._agFetchWalletButtons().finally(() => { this._agWalletFetch = null; });
    return this._agWalletFetch;
  }

  async _agFetchWalletButtons() {
    // agcd-fix: re-resolve the wrapper at inject time so a rebuild mid-fetch can't strand the
    // injected markup on a detached node.
    const paymentWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
    if (!paymentWrapper) {
      return;
    }

    try {
      // Fetch the cart page which should have the checkout buttons
      const response = await fetch('/cart');
      if (!response.ok) {
        throw new Error('Failed to fetch cart');
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Look for checkout buttons in the cart page
      // They might be in a form or in a specific container
      let checkoutButtons = doc.querySelector('#dynamic-checkout-cart, .dynamic-checkout__content');
      
      // If not found, try to find shopify-accelerated-checkout-cart component
      if (!checkoutButtons) {
        checkoutButtons = doc.querySelector('shopify-accelerated-checkout-cart');
      }
      
      // If still not found, look for the wrapper
      if (!checkoutButtons) {
        const wrapper = doc.querySelector('.shop-pay-button-wrapper, .cart-drawer__dynamic-checkout');
        if (wrapper) {
          checkoutButtons = wrapper.querySelector('shopify-accelerated-checkout-cart, #dynamic-checkout-cart, .dynamic-checkout__content') || wrapper;
        }
      }
      
      if (checkoutButtons && checkoutButtons.innerHTML.trim()) {
        // Get the inner HTML or outer HTML depending on what we found
        const buttonsHTML = checkoutButtons.tagName === 'SHOPIFY-ACCELERATED-CHECKOUT-CART' 
          ? checkoutButtons.outerHTML 
          : checkoutButtons.innerHTML;
        
        paymentWrapper.innerHTML = buttonsHTML;
        console.log('Loaded dynamic checkout buttons HTML');
        
        // Wait a bit for the web component to initialize
        setTimeout(() => {
          this.initializePaymentButtons();
        }, 200);
      } else {
        console.log('No checkout buttons found, hiding wrapper');
        paymentWrapper.style.display = 'none';
      }
    } catch (error) {
      console.error('Error loading checkout buttons:', error);
      paymentWrapper.style.display = 'none';
    }
  }

  renderCartItem(item, index) {
    const esc = this._agEsc;
    const info = this._agProductInfo(item.handle);
    // finishing samples are UNLISTED products and never in the baked asset: same rule as the Liquid render
    const sample = /^finish sample$/i.test(item.product_type || '');
    const title = (info && info.t) || (sample ? 'Finishing sample · ' + String(item.product_title || '').replace(/^Finish:\s*/i, '') : item.product_title || item.title || '');
    // the line's own variant image when it is a studio render (assets/ag-sets.json vr; Datch 2026-10-14, "Variant render,
    // else today"); a variant photographed in a room keeps the product's lead render. Same choice as the Liquid render.
    const vfile = item.image ? String(item.image).split('?')[0].split('/').pop() : '';
    const vr = this._agSets && Array.isArray(this._agSets.vr) ? (this._agVr || (this._agVr = new Set(this._agSets.vr))) : null;
    const vsrc = vfile && vr && vr.has(vfile) ? String(item.image) + (String(item.image).indexOf('?') >= 0 ? '&' : '?') + 'width=160' : '';
    let src = vsrc || (info && info.img) || item.image || '';
    // an executive desk (Return Desk) or reception desk (Reception Configuration) line whose picture shows the other side
    // is flipped (Datch 2026-10-14): the other side's studio render in the same finish (ag-sets cf), else the main render
    // when its side is known and differs (ag-sets ms). Custom-finishing lines keep agcf's own preview. Same as the Liquid.
    const sideOpt = (item.options_with_values || []).find((o) => o && (o.name === 'Return Desk' || o.name === 'Reception Configuration'));
    const side = sideOpt ? (/left/i.test(sideOpt.value) ? 'L' : /right/i.test(sideOpt.value) ? 'R' : '') : '';
    const custom = item.properties && (item.properties['Custom Finishing'] || item.properties['_preview']);
    let flip = false;
    if (side && !vsrc && !custom && this._agSets) {
      const cfFile = this._agSets.cf && this._agSets.cf[item.variant_id];
      if (cfFile) { src = this._agImg(cfFile); flip = true; }
      else if (info && info.img && src === info.img && this._agSets.ms && this._agSets.ms[item.handle] && this._agSets.ms[item.handle] !== side) flip = true;
    }
    // cart picture map (Ansen 2026-10-16): a light gray studio picture per variant from Shopify Files (assets/ag-cart-vm.json:
    // { variantId: [file, flipped] }; ag-sets vm is only a fallback) wins over the variant image, the flipped other side and
    // the main render. Custom-finishing lines keep agcf's own preview. Same choice as the Liquid render (cart-variant-map).
    // Round 3 (Ansen 2026-10-16): a custom-finishing line uses the same gray picture as its stand-in until its own preview
    // is painted over it (it fell back to the white main render while the preview was still being made). Never flipped
    // for those lines: agcf swaps the src without touching the flip class, so a flip would mirror the finished preview.
    const vmMap = this._agVmMap();
    const vmE = vmMap ? vmMap[item.variant_id] : null;
    if (vmE) { src = this._agImg(vmE[0]); flip = !custom && !!vmE[1]; }
    // a workstation line with Orientation: Left (the side picker, assets/agwc-side.js): every workstation picture shows the
    // RIGHT build, so the thumbnail is mirrored, as the product page does (Datch 2026-10-14). Same as the Liquid render.
    if (!custom && /^left$/i.test(String((item.properties && item.properties.Orientation) || '').trim())) flip = true;
    const image = src ? `<img src="${esc(src)}" alt="" class="cart-drawer__item-image-img${flip ? ' cart-drawer__item-image-img--flip' : ''}" width="80" height="80" loading="lazy">` : '';
    const money = (c) => this.formatMoney(c).replace(/\.00$/, '');
    // the LINE total, unit x quantity, as snippets/cart-drawer.liquid (Datch 2026-10-12 12:30, reversing the morning's
    // unit-price ruling: a quantity-2 desk reads $3,420); a discounted line stacks the struck list total over the final total
    const lineOriginal = item.original_line_price, lineFinal = item.final_line_price;
    let priceHtml;
    if (lineOriginal !== lineFinal) {
      priceHtml = `<s class="cart-drawer__item-price-compare">${money(lineOriginal)}</s><span class="cart-drawer__item-price-final">${money(lineFinal)}</span>`;
    } else if (this.agUniformRate > 0) {
      priceHtml = `<s class="cart-drawer__item-price-compare">${money(lineOriginal)}</s><span class="cart-drawer__item-price-final">${money(Math.round(lineOriginal * (100 - this.agUniformRate) / 100))}</span>`;
    } else {
      priceHtml = `<span class="cart-drawer__item-price-final">${money(lineOriginal)}</span>`;
    }
    // the variant as a label list (SIZE / RETURN / FINISH ...), then the line properties the theme shows. A custom-finishing
    // line (agcf's "Custom Finishing" property) shows its combo as the ONE FINISH row, and no separate property row (Datch
    // 2026-10-13): the variant's standard finish is not what is made. snippets/cart-drawer-item.liquid does the same.
    const cf = item.properties && item.properties['Custom Finishing'];
    const combo = typeof cf === 'string' && cf.trim() ? cf.trim().split(' & ').join(' and ') : '';
    // 2g (Ansen 2026-10-17): the Finish preview ID in brackets after the finish + an (i); its note says to call
    const fpv = item.properties && typeof item.properties['Finish preview ID'] === 'string' ? item.properties['Finish preview ID'].trim() : '';
    const fpTag = fpv ? AG_FP_TAG(esc(fpv)) : '';
    let rows = '', finRow = false;
    const SRf = window.AGSR;
    const agFinCodes = () => {
      const c = item.properties && item.properties._finish_codes;
      if (!c) return '';
      const d = SRf && typeof SRf.dots === 'function' ? SRf.dots(String(c)) : '';
      return d || '<span class="ag-fslot" data-ag-codes="' + esc(String(c)) + '"></span>';
    };
    if (!item.product_has_only_default_variant) {
      (item.options_with_values || []).forEach((o) => {
        if (!o || o.name === 'Variant' || o.value === 'Default Title') return;
        const label = this._agOptLabel(o.name);
        let value = o.value;
        if (combo && label === 'Finish') { value = combo; finRow = true; }
        // PDP polish round 4 (Ansen 2026-10-17, board 7A): the Finish row starts with the finish's dots - a custom finish
        // from its codes, a standard one from the variant's own two finishes, which it then names ("Red Mahogany and Dark
        // Slate Matte"; ag-set-renders.js fills the placeholder when the product's finishes are not known yet)
        let fin = '', val = esc(value);
        if (label === 'Finish') {
          if (combo) fin = agFinCodes();
          else {
            const fe = SRf && typeof SRf.finSync === 'function' ? SRf.finSync(item.handle, item.variant_id) : null;
            fin = fe ? SRf.finDots(fe) : (SRf && SRf.finFor ? '<span class="ag-fslot" data-ag-h="' + esc(item.handle) + '" data-ag-v="' + esc(String(item.variant_id)) + '"></span>' : '');
            val = '<span class="ag-fname">' + esc(fe ? SRf.finNames(fe) : value) + '</span>';
          }
        }
        rows += '<div class="cart-drawer__item-option"><dt>' + esc(label) + '</dt><dd>' + fin + val + (combo && label === 'Finish' ? fpTag : '') + '</dd></div>';
      });
    }
    if (combo && !finRow) rows += '<div class="cart-drawer__item-option"><dt>Finish</dt><dd>' + agFinCodes() + esc(combo) + fpTag + '</dd></div>';
    Object.keys(item.properties || {}).forEach((name) => {
      const value = item.properties[name];
      if (String(name).charAt(0) === '_') return;
      if (combo && name === 'Custom Finishing') return;
      if (name === 'Finish preview ID') return;   // 2g: shown on the Finish row
      if (typeof value !== 'string' || value.trim() === '') return;
      const body = value.indexOf('/uploads/') >= 0
        ? '<a href="' + esc(value) + '" class="link" target="_blank" rel="noopener">' + esc(value.split('/').pop()) + '</a>'
        : esc(value);
      // the workstation side picker's Orientation property prints as SIDE, as in the Liquid render
      rows += '<div class="cart-drawer__item-option"><dt>' + esc(name === 'Orientation' ? 'Side' : name) + '</dt><dd>' + body + '</dd></div>';
    });
    return `
      <div class="cart-drawer__item" id="cart-drawer-item-${index}">
        <div class="cart-drawer__item-image">${image}</div>
        <div class="cart-drawer__item-details">
          <div class="cart-drawer__item-head">
            <h3 class="cart-drawer__item-title"><a href="${esc(this._agCarryUrl(item))}" class="cart-drawer__item-link">${esc(title)}</a></h3>
            <div class="cart-drawer__item-price">${priceHtml}</div>
          </div>
          ${rows ? '<dl class="cart-drawer__item-options">' + rows + '</dl>' : ''}
          <div class="cart-drawer__item-quantity">
            <div class="quantity">
              <button class="quantity__button quantity__button--minus" type="button" name="minus" aria-label="Decrease quantity">
                <svg class="icon icon-minus" viewBox="0 0 10 2" aria-hidden="true" focusable="false"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.8.5 1 .5h8c.3 0 .5.2.5.5s-.2.5-.5.5H1C.8 2 .5 1.8.5 1z" fill="currentColor"></path></svg>
              </button>
              <input class="quantity__input" type="number" name="updates[]" value="${item.quantity}" min="0" data-index="${index}" aria-label="Quantity">
              <button class="quantity__button quantity__button--plus" type="button" name="plus" aria-label="Increase quantity">
                <svg class="icon icon-plus" viewBox="0 0 10 10" aria-hidden="true" focusable="false"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49 1a.5.5 0 00-1 .01v3.5L1 4.51z" fill="currentColor"></path></svg>
              </button>
            </div>
            <div class="cart-drawer__item-remove">
              <button type="button" class="cart-drawer__item-remove-button">Remove</button>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  updateTotals(cart) {
    console.log('updateTotals called with cart:', cart);
    console.log('cart.total_price:', cart.total_price);

    /* Value-only quick path after the full repaint (showCartItems writes the rows: one per discount since
       2026-10-12). Only the final figure and the checkout button are touched here; a first-match selector on the
       discount rows clobbered the wrong row once (Datch bug report 2026-10-06), so the rows are never updated here. */
    const finalElement = this.querySelector('.cart-drawer__subtotal .cart-drawer__subtotal-price');
    if (finalElement) {
      finalElement.textContent = this.formatMoney(cart.total_price).replace(/\.00$/, '');
      console.log('Updated final total to:', this.formatMoney(cart.total_price));
    }
    
    // Update checkout button price
    const checkoutButton = this.querySelector('.cart-drawer__checkout-button');
    console.log('Found checkout button:', checkoutButton);
    if (checkoutButton) {
      const formattedPrice = this.formatMoney(cart.total_price).replace(/\.00$/, '');
      const newText = `Checkout \u00b7 ${formattedPrice}`;
      checkoutButton.textContent = newText;
      console.log('Updated checkout button to:', newText);
    } else {
      console.log('Checkout button not found!');
    }
  }

  updateCartCount(cart) {
    const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
    cartCountElements.forEach(element => {
      element.textContent = cart.item_count;
    });
    // the drawer header's own count (redesign 2026-10-11) counts LINES, not units: a desk + five samples reads "2 items" (spec header)
    // the drawer header counts UNITS like the header badge (Datch 2026-10-12 18:40; it counted lines before) and, like the
    // badge (snippets/header-navigation.liquid), leaves out the custom-finishing surcharge's units (2026-10-13: a custom
    // desk + shelves read "11 items")
    let units = cart.item_count || 0;
    (cart.items || []).forEach((it) => { if (String(it.handle || '').indexOf('custom-finishing-surcharge') === 0) units -= it.quantity || 0; });
    units = Math.max(0, units);
    this.querySelectorAll('[data-cart-drawer-count]').forEach((el) => { el.textContent = units + (units === 1 ? ' item' : ' items'); });
  }

  // ---- agwg start: white glove eligibility for the cart callout --------------
  // The callout above is re-emitted on every rebuild, but WHETHER it may claim
  // availability depends on what is in the cart. Rule T (A's ruling), as amended
  // by SPEC 135 (2026-09-25, W4): a product is eligible when it carries one of
  // FOUR exact ship-type tags - Prod_Quickship now included - and a finish
  // sample (tag `ag-sample`) is never eligible, whatever else it carries.
  // Untagged or unresolved is NOT eligible. The sessionStorage key moved
  // v1 -> v2 with that amendment, so a verdict cached under the old rule is
  // never read again.
  //
  // TRUTHFUL DEFAULT IS HIDE. The markup ships in the unknown state and the
  // stylesheet hides unknown + none, so a cart whose eligibility cannot be
  // established shows nothing rather than a claim we cannot stand behind. The
  // callout can therefore only ever APPEAR late - it never swaps copy in front of
  // a customer, and it never retracts a claim it has already made.
  //
  // Channel: /products/<handle>.js, which returns the product's tags. Measured
  // 2026-08-15: cf-cache-status DYNAMIC, 104-153 ms - NOT CDN-cached, so the
  // sessionStorage cache, the single-flight map and the handle dedupe are
  // load-bearing rather than optimisations. A missing handle 404s with an EMPTY
  // body, so .json() throws and lands in the unresolved path by design.

  _agwgClassify(tags) {
    var i;
    if (!tags || !tags.length) { return 0; }
    // Samples first - a finish sample outranks every other tag (SPEC 135 W4:
    // Samples stay excluded).
    for (i = 0; i < tags.length; i++) {
      if (tags[i] === 'ag-sample') { return 0; }
    }
    // EXACT equality only. Live products carry overlapping-prefix tags such as
    // Customization_Customizable next to Prod_Overseas In-Stock, so a substring or
    // startsWith test would misclassify them.
    for (i = 0; i < tags.length; i++) {
      if (tags[i] === 'Prod_Quickship' ||
          tags[i] === 'Prod_Customizable' ||
          tags[i] === 'Prod_Made to Order' ||
          tags[i] === 'Prod_Overseas In-Stock') { return 1; }
    }
    return 0;
  }

  _agwgCache() {
    if (this._agwgMem) { return this._agwgMem; }
    var raw = null, map = {};
    try { raw = window.sessionStorage.getItem('agwg_ft_v2'); } catch (e) { raw = null; }
    if (raw) { try { map = JSON.parse(raw) || {}; } catch (e) { map = {}; } }
    this._agwgMem = map;
    return map;
  }

  _agwgRemember(handle, value) {
    var map = this._agwgCache(), keys, i;
    map[handle] = value;
    keys = Object.keys(map);
    // Bounded: a long browsing session must not grow this without limit.
    if (keys.length > 200) {
      for (i = 0; i < keys.length - 200; i++) { delete map[keys[i]]; }
    }
    this._agwgMem = map;
    // Every storage touch is guarded: a throw here runs inside the rebuild path
    // and would take the note field and checkout button down with it.
    try { window.sessionStorage.setItem('agwg_ft_v2', JSON.stringify(map)); } catch (e) {}
  }

  _agwgHandles(cart) {
    var out = [], seen = {}, items = (cart && cart.items) || [], i, h;
    for (i = 0; i < items.length; i++) {
      h = items[i] && items[i].handle;
      if (h && !seen[h]) { seen[h] = 1; out.push(h); }
    }
    return out;
  }

  _agwgFetch(handle) {
    var self = this;
    if (!this._agwgFlight) { this._agwgFlight = new Map(); }
    if (this._agwgFlight.has(handle)) { return this._agwgFlight.get(handle); }
    var p = fetch('/products/' + encodeURIComponent(handle) + '.js',
                  { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) { throw new Error('agwg status ' + r.status); }
        return r.json();
      })
      .then(function (d) {
        // A missing tags key is UNRESOLVED, never "no tags" - the difference is a
        // hidden callout versus a false one.
        if (!d || !Array.isArray(d.tags)) { throw new Error('agwg no tags'); }
        var v = self._agwgClassify(d.tags);
        self._agwgRemember(handle, v);
        return v;
      })
      .catch(function () { return null; })
      .finally(function () { self._agwgFlight.delete(handle); });
    this._agwgFlight.set(handle, p);
    return p;
  }

  _agwgPaint(seq, handles, node) {
    if (seq !== this._agwgSeq) { return; }
    // Re-query from whatever is live. Holding the footer node across an await is
    // how the wallet fix stranded markup on a detached tree; the async repaint
    // therefore looks the element up again instead of closing over it.
    var el = node ? node.querySelector('.agwg-cartline')
                  : this.querySelector('.agwg-cartline');
    if (!el) { return; }
    var map = this._agwgCache(), elig = 0, other = 0, unres = 0, i, v;
    for (i = 0; i < handles.length; i++) {
      v = map[handles[i]];
      if (typeof v === 'undefined') { unres++; }
      else if (v === 1) { elig++; }
      else { other++; }
    }
    var state = 'none';
    if (elig > 0) { state = (other === 0 && unres === 0) ? 'all' : 'some'; }
    el.setAttribute('data-agwg-state', state);
    // D1 (A's pick, 2026-08-15): the LABEL carries the qualification. Same
    // element, same register, caps either way - only the string changes, and
    // only in the mixed state. It is restated on every paint rather than only
    // when mixed, so a cart that goes some -> all (remove the ineligible line)
    // returns to the unqualified claim without a reload.
    var lab = el.querySelector('.agwg-cartline-label');
    if (lab) {
      lab.textContent = (state === 'some')
        ? 'WHITE GLOVE DELIVERY AVAILABLE FOR SELECT ITEMS'
        : 'WHITE GLOVE DELIVERY AVAILABLE';
    }
  }

  _agwgStamp(footer, cart) {
    var self = this;
    // Monotonic sequence: a rebuild that lands while a fetch is in flight makes
    // the older resolver a no-op instead of letting it stamp a stale cart's answer.
    var seq = (this._agwgSeq = (this._agwgSeq || 0) + 1);
    var handles = this._agwgHandles(cart);
    var map = this._agwgCache(), pending = [], jobs = [], i;
    for (i = 0; i < handles.length; i++) {
      if (typeof map[handles[i]] === 'undefined') { pending.push(handles[i]); }
    }
    // Synchronous paint against the node about to be attached: a warm cache
    // resolves before the first frame, so repeat opens never show a flash.
    this._agwgPaint(seq, handles, footer);
    if (!pending.length) { return; }
    for (i = 0; i < pending.length; i++) { jobs.push(this._agwgFetch(pending[i])); }
    Promise.all(jobs).then(function () { self._agwgPaint(seq, handles); });
  }

  _agwgWarm(cart) {
    // Fire-and-forget on every cart refresh so the NEXT open can stamp
    // synchronously. Deliberately unawaited - it must never delay the drawer.
    var handles = this._agwgHandles(cart), map = this._agwgCache(), i;
    for (i = 0; i < handles.length; i++) {
      if (typeof map[handles[i]] === 'undefined') { this._agwgFetch(handles[i]); }
    }
  }
  // ---- agwg end --------------------------------------------------------------

  // ---- redesign helpers (2026-10-11) ----------------------------------------
  _agEsc(v) {
    return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  // one short word per label so it fits the 64 px label column; the same map as snippets/cart-drawer-item.liquid
  // (Datch 2026-10-14, option 5: Configuration, Seating Type and Upholstery collided with their values)
  _agOptLabel(name) {
    const map = { 'Size': 'Size', 'Return Desk': 'Return', 'Finishing Color': 'Finish', 'Finishing': 'Finish', 'Primary Finishing': 'Finish', 'Set Size': 'Set size', 'Desk Style': 'Style', 'Reception Configuration': 'Layout', 'Configuration': 'Layout', 'Seating Type': 'Seating', 'Upholstery': 'Material' };
    return map[name] || name;
  }
  /* assets/ag-sets.json (baked by workspace tools/bake-sets-asset.mjs): short titles, lead renders, set membership,
     ranks and variants. One fetch per page, cached by the CDN; the drawer waits at most 1.5 s for it on the first
     paint and renders full titles and the line images until it lands. */
  _agAsset() {
    if (this._agAssetPromise) return this._agAssetPromise;
    const url = this.getAttribute('data-ag-sets-url');
    // the cart picture map has its own file (assets/ag-cart-vm.json, Ansen 2026-10-16), so re-baking ag-sets.json never drops it
    const vmUrl = this.getAttribute('data-ag-cart-vm-url');
    const vmP = vmUrl ? fetch(vmUrl, { cache: 'force-cache' }).then((r) => (r.ok ? r.json() : null)).then((j) => { this._agVm = j && typeof j === 'object' ? j : null; }).catch(() => null) : Promise.resolve();
    if (!url) return (this._agAssetPromise = vmP.then(() => null));
    const setsP = fetch(url, { cache: 'force-cache' }).then((r) => (r.ok ? r.json() : null)).then((j) => { this._agSets = j || null; return this._agSets; }).catch(() => null);
    this._agAssetPromise = Promise.all([setsP, vmP]).then(() => this._agSets);
    return this._agAssetPromise;
  }
  // the cart picture map (assets/ag-cart-vm.json { vm, vi }; ag-sets vm is only a fallback): variantId -> [file, flipped]
  _agVmMap() {
    const V = this._agVm;
    return (V && V.vm) || (this._agSets && this._agSets.vm) || null;
  }
  // the picture the cart would show for a set member's variant (Ansen 2026-10-16: the set card shows the offered piece in
  // the matched finish): the map first, else the variant's own studio render (vr), else the other side flipped (cf) or the
  // lead render flipped when its known side differs (ms), else the lead render. Same order as renderCartItem.
  _agCardPic(m, v) {
    const A = this._agSets || {};
    const vm = this._agVmMap();
    const e = vm && v ? vm[v.id] : null;
    if (e) return { src: this._agImg(e[0]), flip: !!e[1] };
    const vi = (this._agVm && this._agVm.vi) || {};
    const f = v ? vi[v.id] : '';
    const vr = Array.isArray(A.vr) ? (this._agVr || (this._agVr = new Set(A.vr))) : null;
    if (f && vr && vr.has(f) && f !== m.img) return { src: this._agImg(f), flip: false };
    const side = v && v.ret ? (/left/i.test(v.ret) ? 'L' : /right/i.test(v.ret) ? 'R' : '') : '';
    if (side) {
      const cfFile = A.cf && A.cf[v.id];
      if (cfFile) return { src: this._agImg(cfFile), flip: true };
      if (A.ms && A.ms[m.h] && A.ms[m.h] !== side) return { src: this._agImg(m.img), flip: true };
    }
    return { src: this._agImg(m.img), flip: false };
  }
  _agImg(name) {
    const A = this._agSets;
    if (!name) return '';
    if (/^https?:/.test(name)) return name;
    return ((A && A.base) || '') + name + '?width=160';
  }
  _agProductInfo(handle) {
    const A = this._agSets;
    const p = A && A.products && handle ? A.products[handle] : null;
    return p ? { t: p.t, set: p.set, type: p.type, img: this._agImg(p.img) } : null;
  }
  _agTrack(name, payload) {
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, payload); } catch (e) { /* never */ }
    try {
      const g = { send_to: 'G-NSBRHF1SPE' };
      Object.keys(payload).forEach((k) => { const v = payload[k]; if (v === null || v === undefined) return; g['ag_' + k] = typeof v === 'boolean' ? (v ? 1 : 0) : v; });
      // 2026-10-13 (dry run, finding F1): the Google channel's gtag loads asynchronously, so an event fired before it
      // exists used to be dropped. Events now wait for gtag (polled every 250 ms, up to 20 s) and flush in order.
      this._agGaQ = this._agGaQ || [];
      if (!this._agGaQ.length && typeof window.gtag === 'function') { window.gtag('event', name, g); return; }
      this._agGaQ.push([name, g]);
      if (this._agGaTimer) return;
      let ticks = 0;
      this._agGaTimer = setInterval(() => {
        ticks++;
        if (typeof window.gtag === 'function') { while (this._agGaQ.length) { const q = this._agGaQ.shift(); try { window.gtag('event', q[0], q[1]); } catch (e) { /* never */ } } }
        if (!this._agGaQ.length || ticks > 80) { clearInterval(this._agGaTimer); this._agGaTimer = null; if (ticks > 80) this._agGaQ.length = 0; }
      }, 250);
    } catch (e) { /* never */ }
  }
  _agBindNote(footer) {
    const box = footer.querySelector('[data-cart-note]');
    const toggle = footer.querySelector('[data-cart-note-toggle]');
    const ta = footer.querySelector('#cart-drawer-note');
    if (!box || !toggle || !ta) return;
    toggle.addEventListener('click', () => {
      const open = box.classList.toggle('cart-drawer__note--open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { ta.focus(); } else { toggle.textContent = ta.value.trim() ? 'Edit your note' : 'Add a note to your order'; const p = box.querySelector('.cart-drawer__note-preview'); if (p) p.textContent = ta.value.trim(); }
    });
  }
  /* the matching-set cards (spec §2): one card per set in the cart that still lacks a type (Datch 2026-10-12 18:40);
     per set, its newest cart line leads: the first missing type in the PDP card's order; the piece in that line's
     finish (else its single finish); the first available size; the ladder from the count of distinct set products of
     that set in the cart (1 -> 5% next, 2 -> 8% next, 3+ -> no card). */
  // THE CHAIR IN THESE PHOTOS (Ansen 2026-10-17, canvas 65fhQBKaMeFeQ13A3mHNQw boards 3A/5A/6B): under a desk or table
  // line, and under its set card, the chair its product page offers (custom.shown_with_chair, read through the
  // product's ag-chair-data view, so it is always the product's current pick), from the first paint. A desk starts at
  // one chair per desk; a conference table at one per seat ("(Seats up to N)" in its size), with - and +. Gone once
  // that chair is in the cart, or when it is sold out. The set card is untouched; the chair is not part of the set saving.
  _agChairData(handle) {
    const c = (this._agChairCache = this._agChairCache || {});
    if (Object.prototype.hasOwnProperty.call(c, handle)) return c[handle];
    const sk = 'ag-chair:v2:' + handle;
    try { const s = sessionStorage.getItem(sk); if (s) { c[handle] = JSON.parse(s); return c[handle]; } } catch (e) { /* storage off */ }
    // no Accept header: asked for application/json, Shopify answers the product record instead of this view
    c[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=ag-chair-data', { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.text() : ''))
      .then((t) => {
        const raw = String(t).trim();
        let d;
        try { d = JSON.parse(raw); } catch (e) { d = undefined; }
        const known = raw === 'null' || (d && typeof d === 'object' && d.h && d.v);
        if (!known) { c[handle] = null; return null; }   // not this view's answer: no card on this page (not kept: the next page asks again)
        c[handle] = d || null;
        try { sessionStorage.setItem(sk, JSON.stringify(c[handle])); } catch (e) { /* storage off */ }
        return c[handle];
      })
      .catch(() => { c[handle] = null; return null; });   // offline: no card on this page, never a retry loop
    return c[handle];
  }

  _agChairRow(cart) {
    this._agChairCart = cart;
    const items = (cart && cart.items) || [];
    this._agChairWait = this._agChairWait || new Set();
    // round 4 (board 11A): chairs already in the cart, by variant; each desk or table line uses them up in the drawer's
    // order (oldest first). A line still short gets its own card (two finishes = two cards); a chair line in the cart
    // is tied to the first line it serves.
    const have = {};
    items.forEach((it) => { const v = String(it.variant_id); have[v] = (have[v] || 0) + (it.quantity || 1); });
    const wants = [], ties = [];
    items.map((it, index) => ({ it, index })).reverse().forEach(({ it, index }) => {
      const type = String(it.product_type || '');
      if (!/desk|conference/i.test(type) || /chair|seating/i.test(type)) return;
      const d = this._agChairData(it.handle);
      if (d && typeof d.then === 'function') {
        if (!this._agChairWait.has(it.handle)) {
          this._agChairWait.add(it.handle);
          d.then(() => { this._agChairWait.delete(it.handle); if (this.isConnected && this._agChairCart) this._agChairRow(this._agChairCart); });
        }
        return;
      }
      if (!d || !d.v) return;
      const table = /conference/i.test(type);
      const words = (it.options_with_values || []).map((o) => o.value).join(' ') + ' ' + (it.variant_title || '');
      const seats = table ? (+((/seats up to\s*(\d+)/i.exec(words) || [])[1]) || 1) : 1;
      const need = seats * (it.quantity || 1);
      const v = String(d.v);
      const got = Math.min(need, have[v] || 0);
      have[v] = (have[v] || 0) - got;
      // stage D (board 7A): the product's name, "Hershey" from "Hershey · Modern L-Shaped Executive Desk"
      const pt = String(it.product_title || '');
      const nm = pt.indexOf(' · ') > 0 ? pt.split(' · ')[0].trim() : '';
      if (got > 0) ties.push({ v, index, nm, word: table ? 'table' : 'desk' });
      if (got < need && d.a) wants.push({ d, qty: need - got, table, index, seats, lines: 1, names: nm ? [nm] : [], key: d.h + '@' + index });
    });
    const keys = new Set(wants.map((w) => w.key));
    this.querySelectorAll('[data-ag-cart-chair]').forEach((h) => { if (!keys.has(h.getAttribute('data-ag-chair-key'))) h.remove(); });
    const tied = {};
    ties.forEach((t) => { if (!tied[t.v]) { tied[t.v] = true; this._agTieChairLine(t, items); } });
    wants.forEach((w) => this._agPaintChair(w));
  }

  // where a desk line's chair things go: after the line, or after its set group (the line and its set card stay
  // together), and after any chair line or card already tied there
  _agChairAnchor(index) {
    const itemEl = this.querySelector('#cart-drawer-item-' + (index + 1));
    if (!itemEl) return null;
    return itemEl.closest('.cart-drawer__set-group') || itemEl;
  }

  _agTieChairLine(t, items) {
    const esc = this._agEsc;
    const ci = items.findIndex((it) => String(it.variant_id) === t.v);
    const el = ci >= 0 ? this.querySelector('#cart-drawer-item-' + (ci + 1)) : null;
    const anchor = this._agChairAnchor(t.index);
    if (!el || !anchor || el.contains(anchor)) return;
    if (anchor.nextElementSibling !== el) anchor.insertAdjacentElement('afterend', el);
    el.classList.add('cart-drawer__item--tied');
    el.setAttribute('data-ag-tied-to', String(t.index));
    if (!el.querySelector(':scope > .ag-cart-chair__tie')) el.insertAdjacentHTML('afterbegin', '<span class="ag-cart-chair__tie" aria-hidden="true"></span>');
    const head = el.querySelector('.cart-drawer__item-head');
    const label = t.nm ? 'For your ' + t.nm + ' ' + t.word : 'For your ' + t.word;
    let f = el.querySelector('[data-ag-chair-for]');
    if (!f && head) { head.insertAdjacentHTML('afterend', '<p class="ag-cart-chair__for" data-ag-chair-for></p>'); f = el.querySelector('[data-ag-chair-for]'); }
    if (f) f.textContent = label;
  }

  _agPaintChair(w) {
    const esc = this._agEsc, d = w.d;
    const anchor = this._agChairAnchor(w.index);
    if (!anchor) return;
    let host = null;
    this.querySelectorAll('[data-ag-cart-chair]').forEach((h) => { if (h.getAttribute('data-ag-chair-key') === w.key) host = h; });
    if (!host) { host = document.createElement('div'); host.className = 'ag-cart-chair is-tied'; host.setAttribute('data-ag-cart-chair', d.h); host.setAttribute('data-ag-chair-key', w.key); }
    // after the desk's own tied chair line, if it has one
    let after = anchor;
    const nx = after.nextElementSibling;
    if (nx && nx !== host && nx.getAttribute('data-ag-tied-to') === String(w.index)) after = nx;
    if (after.nextElementSibling !== host) after.insertAdjacentElement('afterend', host);
    const picked = (this._agChairQty = this._agChairQty || {});
    const money = (c) => this.formatMoney(c).replace(/\.00$/, '');
    const paint = () => {
      const q = Math.max(1, Math.min(99, picked[w.key] || w.qty || 1));
      const seatsNote = w.table && w.seats > 1 ? `<span class="ag-cart-chair__seats">Table seats up to ${w.seats}</span>` : '';
      host.innerHTML = `
      <span class="ag-cart-chair__tie" aria-hidden="true"></span>
      <span class="ag-cart-chair__kicker">The chair in ${w.names.length ? 'the ' + esc(w.names.join(' and ')) : 'these'} photos</span>
      <div class="ag-cart-chair__main">
        ${d.img ? `<img class="ag-cart-chair__img" src="${esc(d.img)}" alt="" width="64" height="64" loading="lazy">` : ''}
        <div class="ag-cart-chair__body">
          <a class="ag-cart-chair__title" href="${esc(d.u)}">${esc(d.t)}</a>
          <span class="ag-cart-chair__each">${money(d.p)}${w.table ? ' each' : ''}</span>
          ${w.table ? `<div class="ag-cart-chair__qty"><button type="button" class="ag-cart-chair__step" data-ag-step="-1" aria-label="One chair fewer"${q <= 1 ? ' disabled' : ''}>&minus;</button><span class="ag-cart-chair__n" aria-live="polite">${q}</span><button type="button" class="ag-cart-chair__step" data-ag-step="1" aria-label="One chair more"${q >= 99 ? ' disabled' : ''}>+</button>${seatsNote}</div>` : ''}
        </div>
        <button type="button" class="ag-cart-chair__add" aria-label="Add ${q} ${esc(d.t)} to your cart, ${esc(money(d.p * q))}"><span class="ag-cart-chair__add-word">Add${q > 1 ? ' ' + q : ''}</span><span class="ag-cart-chair__add-price">${money(d.p * q)}</span></button>
      </div>`;
      // a repaint waits for the click to finish bubbling (the drawer's click-outside check reads a detached button as outside)
      host.querySelectorAll('.ag-cart-chair__step').forEach((b) => b.addEventListener('click', () => {
        picked[w.key] = Math.max(1, Math.min(99, q + (+b.getAttribute('data-ag-step') || 0)));
        setTimeout(() => { paint(); const nb = host.querySelector('.ag-cart-chair__step[data-ag-step="' + b.getAttribute('data-ag-step') + '"]'); if (nb && !nb.disabled) nb.focus(); }, 0);
      }));
      const btn = host.querySelector('.ag-cart-chair__add');
      btn.addEventListener('click', () => {
        btn.disabled = true;
        // XMLHttpRequest, as the set card's Add: the page's fetch is wrapped for product-page adds
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            delete picked[w.key];
            this._agTrack('ag_cart_chair_add', { chair: d.h, variant: d.v, qty: q, price: d.p });
            this.refreshCart().catch(() => { btn.disabled = false; });
          } else { btn.disabled = false; }
        };
        xhr.onerror = () => { btn.disabled = false; };
        xhr.send(JSON.stringify({ items: [{ id: d.v, quantity: q }] }));
      });
    };
    paint();
  }

  // round 4/5: a cart line's finish, for the set brackets and the set cards: the custom finish codes without the side,
  // else the stock finish option
  _agFinKey(it) {
    const pr = it.properties || {};
    if (pr['Custom Finishing'] && pr._finish_codes) return 'c:' + String(pr._finish_codes).split(';').filter((x) => !/^\s*S=/.test(x)).join(';');
    const fo = (it.options_with_values || []).find((o) => ['Finishing Color', 'Finishing', 'Primary Finishing'].indexOf(o.name) >= 0);
    return 's:' + (fo ? fo.value : '');
  }

  _agSetRow(cart) {
    // ONE CARD PER INCOMPLETE SET (Datch 2026-10-12 18:40): every set in the cart that still lacks a type gets its own
    // card, inside its group (two or more lines) or inside its only line (with the line-level bracket). The set's newest
    // line leads: its type sets the offer order, its finish the match. Cards of sets that no longer qualify are removed.
    const clearAll = () => { this.querySelectorAll('[data-ag-cart-set]').forEach((h) => h.remove()); this.querySelectorAll('.cart-drawer__item--set').forEach((el) => el.classList.remove('cart-drawer__item--set')); };
    const A = this._agSets;
    // without the asset there is no set knowledge: repaint the lines (grouped) and the cards once it arrives
    if (!A || !A.products || !A.sets) { clearAll(); this._agAsset().then((j) => { if (j && !this._agRowRetried) { this._agRowRetried = true; this.showCartItems(cart); } }); return; }
    const lines = (cart.items || []).map((it, index) => ({ it, index, info: A.products[it.handle] })).filter((x) => x.info && x.info.set);
    if (!lines.length) return clearAll();
    // round 5 (Ansen 2026-10-18, board 13): one card per set AND finish group ("as many times as the product they have
    // in the cart"); the saving each card shows still counts the whole set (see _agPaintSetCard)
    const gk = (x) => x.info.set + '|' + this._agFinKey(x.it);
    const groupsInCart = []; lines.forEach((x) => { const k = gk(x); if (groupsInCart.indexOf(k) < 0) groupsInCart.push(k); }); // newest first
    const keep = [];
    groupsInCart.forEach((k) => {
      const setHandle = k.split('|')[0];
      const all = lines.filter((x) => x.info.set === setHandle);
      const host = this._agPaintSetCard(cart, setHandle, all.filter((x) => gk(x) === k), all, k);
      if (host) keep.push(host);
    });
    this.querySelectorAll('[data-ag-cart-set]').forEach((h) => { if (keep.indexOf(h) < 0) h.remove(); });
    this.querySelectorAll('.cart-drawer__item--set').forEach((el) => { if (!el.querySelector('[data-ag-cart-set]')) el.classList.remove('cart-drawer__item--set'); });
  }

  _agPaintSetCard(cart, setHandle, mine, all, groupKey) {
    // round 5: mine = this finish group's lines (what to offer, in which finish); all = the set's lines in the whole
    // cart (the saving)
    all = all || mine;
    groupKey = groupKey || setHandle;
    // mine = this set's cart lines, newest first; returns the card's host element, or null when nothing is offered
    const esc = this._agEsc;
    const A = this._agSets, set = A.sets[setHandle];
    if (!set) return null;
    const FIN = ['Finishing Color', 'Finishing', 'Primary Finishing'];
    const lead = mine[0];
    const inCart = new Set(mine.map((x) => x.it.handle));
    const typesIn = new Set(mine.map((x) => x.info.type));
    // round 5: no early return for a complete set: a finish group still lacking a piece is offered it (null below when
    // the group has every piece)
    // which type to offer first: a desk -> shelving, then the credenza; storage -> a desk, then the other storage piece;
    // a conference table -> the credenza, then shelving (Datch 2026-10-12 18:10: tables are offered their set's storage
    // pieces, never a desk); anything else -> desk, shelving, credenza
    const order = lead.info.type === 'desk' ? ['shelving', 'credenza'] : lead.info.type === 'shelving' ? ['desk', 'credenza'] : lead.info.type === 'credenza' ? ['desk', 'shelving'] : lead.info.type === 'conference' ? ['credenza', 'shelving'] : ['desk', 'shelving', 'credenza'];
    const fo = (lead.it.options_with_values || []).find((o) => FIN.indexOf(o.name) >= 0);
    const finish = fo ? fo.value : null;
    // the lead line in a custom-finishing combo (agcf's line properties): the piece is offered in the same combo at the
    // rate its own page charges, as the product-page card does (Datch 2026-10-13). agcf.js prices it (customizable product
    // pages only); without it the card is not offered for this set: it cannot price the combo, and the standard finish
    // would be the wrong offer.
    const lp = lead.it.properties || {};
    const leadCombo = typeof lp['Custom Finishing'] === 'string' && lp['Custom Finishing'].trim() && lp['_finish_codes']
      ? { name: lp['Custom Finishing'].trim(), codes: String(lp['_finish_codes']) } : null;
    const AGCF = window.AGCF && typeof window.AGCF.comboPrice === 'function' ? window.AGCF : null;
    if (leadCombo && !AGCF) {
      // round 4 (Ansen 2026-10-16: the card was gone on the home page): off a product page the combo price rule is
      // loaded on demand (ag-set-renders.js loadComboPrice) and the cards paint again once it is in
      const SRp = window.AGSR;
      if (SRp && typeof SRp.loadComboPrice === 'function' && !this._agCpTried) {
        this._agCpTried = true;
        SRp.loadComboPrice().then((ok) => { if (ok && this.isConnected) this._agSetRow(cart); });
      }
      return null;
    }
    const comboOf = (v) => (leadCombo ? AGCF.comboPrice(leadCombo.codes, v.p, v.finish || '') : null);
    const priceOf = (v) => { const c = comboOf(v); return c ? c.price : v.p; };
    let pick = null;
    for (let t = 0; t < order.length && !pick; t++) {
      if (typesIn.has(order[t])) continue;
      const cands = set.members.filter((m) => m.type === order[t] && !inCart.has(m.h));
      for (let i = 0; i < cands.length && !pick; i++) {
        const m = cands[i];
        const fins = []; m.variants.forEach((v) => { if (v.finish && fins.indexOf(v.finish) < 0) fins.push(v.finish); });
        let want = null, matched = false;
        if (finish && fins.indexOf(finish) >= 0) { want = finish; matched = true; }
        else if (fins.length === 1) { want = fins[0]; }
        else if (fins.length > 1) { continue; }
        // the largest width in that finish (Ansen 2026-10-16), first listed on a tie; the Change link still offers the rest
        const inches = (s) => { const mm = /(\d+)\s*[′'’]\s*(?:(\d+)\s*[″"”])?/.exec(String(s || '')); return mm ? (+mm[1]) * 12 + (+(mm[2] || 0)) : -1; };
        const v = m.variants.filter((x) => x.a && (want === null || x.finish === want)).reduce((b, x) => (!b || inches(x.size) > inches(b.size) ? x : b), null);
        if (v) pick = { m, v, matched };
      }
    }
    if (!pick) return null;
    // a size or return the shopper chose in a card survives the drawer's redraws (every cart change repaints the cards),
    // remembered per offered piece
    this._agChoices = this._agChoices || {};
    if (this._agChoices[pick.m.h]) { const r = pick.m.variants.find((x) => x.id === this._agChoices[pick.m.h] && x.a && x.finish === pick.v.finish); if (r) pick.v = r; }
    else if (window.AGSR && typeof window.AGSR.choice === 'function') {
      // round 4 (Ansen 2026-10-16: "memorize those"): the width and return last picked for this piece, on any page and
      // after a refresh, in the offered finish when that variant is available
      const c = window.AGSR.choice(pick.m.h), inch = window.AGSR.inches, sideOf = window.AGSR.sideOf;
      if (c && (c.size || c.ret)) {
        const r = pick.m.variants.find((x) => x.a && x.finish === pick.v.finish
          && (!c.size || inch(x.size) === inch(c.size)) && (!c.ret || !x.ret || sideOf(x.ret) === sideOf(c.ret)));
        if (r) pick.v = r;
      }
    }
    // set custom finishes (Ansen 2026-10-16, canvas MUpB4vs5v52DZuwhEbZYWJ): in a combo the piece shows its own preview
    // in that combo (assets/ag-set-renders.js), made with the lead's preview, so it is normally ready. Until it lands the
    // finish row reads "Rendering in ..." and the picture fades in and out over a filling bar (round 2: always, not only
    // after a size change). The Add carries the piece's preview as _preview, so its cart line shows it too.
    const SR = leadCombo && window.AGSR ? window.AGSR : null;
    const lc = SR ? SR.codes(leadCombo.codes) : null;
    const reqOf = (v) => (lc && lc.p && v ? { handle: pick.m.h, p: lc.p, a: lc.a, side: SR.sideOf(v.ret), size: v.size, lead: lead.it.handle } : null);
    // round 5 (Ansen 2026-10-16): in a combo the piece's link opens its page in that combo (agcf.js reads agf/agl)
    const carryQs = (o) => (o ? '&agf=' + encodeURIComponent(o.p + '.' + (o.a || 'none') + '.' + (o.side || 'base')) + '&agl=' + encodeURIComponent(o.lead || '') : '');
    this._agSrFail = this._agSrFail || {};
    const money = (c) => this.formatMoney(c).replace(/\.00$/, '');
    // round 5: the saving follows the set pricing function (Datch's run.js): DIFFERENT products of this set in the
    // whole cart, whatever their finish - 5% at two, 8% at three or more. The offered piece adds one only when that
    // product is not in the cart yet, in any finish.
    const setIds = new Set(all.map((x) => x.it.handle));
    const isNew = !setIds.has(pick.m.h);
    const after = setIds.size + (isNew ? 1 : 0);
    const pieces = setIds.size;
    // one finish, one line per product = today's words; anything more says "your whole set" (Ansen 2026-10-18)
    const single = all.length === mine.length && mine.length === new Set(mine.map((x) => x.it.handle)).size
      && mine.every((x) => (x.it.quantity || 1) === 1);   // stage H: two of a piece on one line is not "both pieces"
    // the offer (Datch 2026-10-12, option 5 "The rate as the figure"): the tier as one Jost figure under "SAVE", what it
    // applies to, the next tier muted; the Add control carries the piece's price in a smaller font. A set with only two
    // member types (24 of 37 sets: desk + shelving) has no third piece, so no "third piece" line; the types counted are
    // those with an available variant
    const setTypes = []; set.members.forEach((m) => { if (m.variants.some((x) => x.a) && setTypes.indexOf(m.type) < 0) setTypes.push(m.type); });
    const hasThird = setTypes.length >= 3;
    const pct = after >= 3 ? '8%' : '5%';
    const offerLead = single ? (after >= 3 ? 'off all three pieces when you add this one' : 'off both pieces when you add this one')
      : (isNew ? 'off your whole set when you add this one' : 'off your whole set');
    const next = after >= 3 ? 'The set&rsquo;s full rate' : (hasThird ? (single ? '8% off all three with a third piece' : '8% off your whole set with a third piece') : '');
    const piece = { desk: 'desk', shelving: 'shelves', credenza: 'credenza', conference: 'table', reception: 'desk' }[lead.info.type] || 'selection';
    // the piece's size, return and finish as the cart lines' label list (SIZE / RETURN / FINISH); the finish row carries
    // the match note. Variant picker (Datch 2026-10-12 17:45, option 4 "Change link, list opens in place"): a Change link
    // after the SIZE and RETURN values opens a hairline list of the values with prices inside the card; a choice closes
    // it, re-prices the Add control and is remembered. The finish is never a choice: it stays matched to the cart line.
    const fam = pick.m.variants.filter((x) => x.a && x.finish === pick.v.finish);
    const sizeChoices = () => { const seen = [], out = []; fam.forEach((x) => { if (!x.size || seen.indexOf(x.size) >= 0) return; if (pick.v.ret && x.ret && x.ret !== pick.v.ret) return; seen.push(x.size); out.push(x); }); return out; };
    const retChoices = () => { const seen = [], out = []; fam.forEach((x) => { if (!x.ret || seen.indexOf(x.ret) >= 0) return; if (pick.v.size && x.size !== pick.v.size) return; seen.push(x.ret); out.push(x); }); return out; };
    let open = null; // 'size' | 'ret' | null
    // the piece's preview right now: { o: the request, url: when known, rendering: being made }; set by srCheck()
    let srNow = { o: null, url: null, rendering: false };
    const finishText = leadCombo ? esc(leadCombo.name.split(' & ').join(' and ')) + ', matched to your ' + piece
      : pick.v.finish ? (pick.matched ? esc(pick.v.finish) + ', matched to your ' + piece : esc(pick.v.finish) + ' only') : '';
    const changeBtn = (which) => '<button type="button" class="ag-cart-set__change" data-ag-change="' + which + '" aria-expanded="' + (open === which ? 'true' : 'false') + '">Change</button>';
    const rowsHtml = () => {
      const rows = [];
      if (pick.v.size) rows.push(['Size', '<span class="ag-cart-set__val">' + esc(pick.v.size) + '</span>' + (sizeChoices().length > 1 ? changeBtn('size') : '')]);
      if (pick.v.ret) rows.push(['Return', '<span class="ag-cart-set__val">' + esc(pick.v.ret) + '</span>' + (retChoices().length > 1 ? changeBtn('ret') : '')]);
      // PDP polish (Ansen 2026-10-17, board 2D): in a combo the Finish row starts with a dot of each picked finish,
      // pulsing while the piece renders (ag-set-renders.js AGSR.dots)
      // round 4 (board 7A): a standard finish names its accent and shows both dots (the piece's own finishes, from its
      // ag-finish-data view; the card paints again once they are in)
      const SR0 = window.AGSR;
      const fe = !leadCombo && pick.v.finish && SR0 && typeof SR0.finSync === 'function' ? SR0.finSync(pick.m.h, pick.v.id) : null;
      this._agFinAsked = this._agFinAsked || {};
      if (!leadCombo && pick.v.finish && !fe && SR0 && SR0.finFor && !this._agFinAsked[pick.m.h]) {
        this._agFinAsked[pick.m.h] = true;
        SR0.finFor(pick.m.h).then(() => { if (host.isConnected && SR0.finSync(pick.m.h, pick.v.id)) paint(); });
      }
      const fdots = leadCombo ? (SR0 && typeof SR0.dots === 'function' ? SR0.dots(leadCombo.codes, srNow.rendering) : '') : (fe ? SR0.finDots(fe) : '');
      const ftext = fe ? esc(SR0.finNames(fe)) + (pick.matched ? ', matched to your ' + piece : ' only') : finishText;
      if (finishText) rows.push(['Finish', fdots + (srNow.rendering ? 'Rendering in ' : '') + ftext]);
      return rows.length ? '<dl class="cart-drawer__item-options ag-cart-set__options">' + rows.map((r) => '<div class="cart-drawer__item-option"><dt>' + r[0] + '</dt><dd>' + r[1] + '</dd></div>').join('') + '</dl>' : '';
    };
    const listHtml = () => {
      if (!open) return '';
      const list = open === 'size' ? sizeChoices() : retChoices();
      return '<div class="ag-cart-set__list" data-ag-list="' + open + '">' + list.map((x) => '<button type="button" class="ag-cart-set__opt' + (x.id === pick.v.id ? ' is-on' : '') + '" data-ag-pick="' + x.id + '"><span>' + esc(open === 'size' ? x.size : x.ret) + '</span><span class="ag-cart-set__opt-price">' + money(priceOf(x)) + '</span>' + (x.id === pick.v.id ? '<span class="ag-cart-set__opt-mark">Chosen</span>' : '') + '</button>').join('') + '</div>';
    };
    // the card is the last child of the set's group (two or more lines; showCartItems renders them together under the
    // bracket); a set with one line in the cart carries the card inside that line, with the line-level bracket
    const itemEl = this.querySelector('#cart-drawer-item-' + (lead.index + 1));
    // round 4: the lead line's OWN group (a set in two finishes has two groups with the same set handle)
    const groupEl = itemEl ? itemEl.closest('.cart-drawer__set-group') : null;
    const parentEl = groupEl || itemEl;
    if (!parentEl) return null;
    let host = null;
    for (const h of parentEl.children) { if (h.hasAttribute && h.hasAttribute('data-ag-cart-set')) host = h; }
    if (!host) { host = document.createElement('div'); host.className = 'ag-cart-set'; host.setAttribute('data-ag-cart-set', groupKey); parentEl.appendChild(host); }
    if (!groupEl) itemEl.classList.add('cart-drawer__item--set');
    const bindAdd = () => {
      const btn = host.querySelector('.ag-cart-set__add');
      if (!btn) return;
      btn.addEventListener('click', () => {
        btn.disabled = true;
        // XMLHttpRequest on purpose: the page's fetch is wrapped by the attach coordinator and the custom-finishing shim,
        // which extend a product-page add; a drawer add must reach Shopify untouched.
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            this._agTrack('ag_cart_set_add', { set: setHandle, slot: pick.m.type, handle: pick.m.h, variant: pick.v.id, price: pick.v.p, pieces });
            this.refreshCart().catch(() => { btn.disabled = false; });
          } else { btn.disabled = false; }
        };
        xhr.onerror = () => { btn.disabled = false; };
        // in a combo: the piece carries the lead line's combo and its own surcharge line (units at the piece's rate,
        // _for_product = the piece, so agcf pairs each surcharge with its own line), and its OWN preview as _preview
        // (never the lead line's; 2026-10-16)
        const items = [{ id: pick.v.id, quantity: 1 }];
        const c = comboOf(pick.v);
        if (leadCombo) items[0].properties = { 'Custom Finishing': leadCombo.name, _finish_codes: leadCombo.codes };
        const so = reqOf(pick.v);
        const pv = so ? (SR.known(so) || (SR.pending(so) ? SR.predict(so) : null)) : null;
        if (leadCombo && pv) items[0].properties._preview = pv;
        if (leadCombo && so && SR.fpOfKey) items[0].properties['Finish preview ID'] = SR.fpOfKey(SR.keyOf(so));   // 2g
        if (leadCombo && c && c.units) items.push({ id: c.vid, quantity: c.units, properties: { _surcharge_for: leadCombo.codes, _for_product: pick.m.h, _units_per_item: String(c.units) } });
        xhr.send(JSON.stringify({ items }));
      });
    };
    // Layout (Datch 2026-10-12): kicker; then the thumbnail (its top on the title's top) beside the title and the label
    // list, the full width of the card; then the offer row, flush with the thumbnail, with the Add control at its right.
    // the piece's preview: known -> shown; else asked for (once per piece, size and combo) and the card repaints when it
    // lands; a refusal or a failure keeps the stock picture for good, quietly
    const srCheck = () => {
      const o = reqOf(pick.v);
      const key = o ? SR.keyOf(o) : '';
      const url = o ? SR.known(o) : null;
      const rendering = !!(o && !url && !this._agSrFail[key]);
      srNow = { o, url, rendering };
      if (rendering) {
        SR.want(o).then((u) => {
          if (!u) this._agSrFail[key] = true;
          const now = reqOf(pick.v);
          if (!host.isConnected || !now || SR.keyOf(now) !== key) return;
          paint();
        });
      }
      // round 2 (Ansen 2026-10-16): any rendering piece fades over the bar, not only after a size change
      host.classList.toggle('is-rendering', rendering);
    };
    const paint = () => {
      srCheck();
      const picHtml = (() => {
        const pic = srNow.url ? { src: srNow.url, flip: false } : this._agCardPic(pick.m, pick.v);
        const img = `<img class="ag-cart-set__img${pic.flip ? ' cart-drawer__item-image-img--flip' : ''}" src="${esc(pic.src)}" alt="" width="64" height="64" loading="lazy">`;
        // round 3: the bar starts where this piece's render really is (each repaint makes a new bar)
        const lag = srNow.rendering && srNow.o && typeof SR.elapsed === 'function' ? (-SR.elapsed(SR.keyOf(srNow.o)) / 1000).toFixed(2) : '0';
        return srNow.rendering ? `<span class="ag-cart-set__pic">${img}<span class="ag-cart-set__bar" aria-hidden="true"><span style="animation-delay:${lag}s"></span></span></span>` : img;
      })();
      host.innerHTML = `
      <span class="ag-cart-set__kicker">Complete the ${esc(set.name)} set</span>
      <div class="ag-cart-set__main">
        ${picHtml}
        <div class="ag-cart-set__body">
          <a class="ag-cart-set__title" href="/products/${esc(pick.m.h)}?variant=${pick.v.id}${esc(carryQs(reqOf(pick.v)))}">${esc(pick.m.t)}</a>
          ${rowsHtml()}${listHtml()}
        </div>
      </div>
      <div class="ag-cart-set__offer">
        <span class="ag-cart-set__offer-text"><span class="ag-cart-set__pct"><span class="ag-cart-set__save">Save</span><span class="ag-cart-set__pct-figure">${pct}</span></span><span class="ag-cart-set__words"><span class="ag-cart-set__lead">${offerLead}</span>${next ? '<span class="ag-cart-set__next">' + next + '</span>' : ''}</span></span>
        <button type="button" class="ag-cart-set__add" data-ag-variant="${pick.v.id}" aria-label="Add ${esc(pick.m.t)} to your cart, ${money(priceOf(pick.v))}"><span class="ag-cart-set__add-word">Add</span><span class="ag-cart-set__add-price">${money(priceOf(pick.v))}</span></button>
      </div>`;
      // the repaint waits for the click to finish bubbling: a synchronous repaint detaches the clicked button, and the
      // drawer's "click outside" handler on document would then read the click as outside and close the drawer
      const repaint = (which) => setTimeout(() => { paint(); const nb = host.querySelector('.ag-cart-set__change[data-ag-change="' + which + '"]'); if (nb) nb.focus(); }, 0);
      host.querySelectorAll('.ag-cart-set__change').forEach((b) => b.addEventListener('click', () => {
        const which = b.getAttribute('data-ag-change');
        open = open === which ? null : which;
        repaint(which);
      }));
      host.querySelectorAll('.ag-cart-set__opt').forEach((b) => b.addEventListener('click', () => {
        const v = pick.m.variants.find((x) => x.id === +b.getAttribute('data-ag-pick'));
        if (!v) return;
        const which = open;
        pick.v = v;
        this._agChoices[pick.m.h] = v.id;
        if (window.AGSR && typeof window.AGSR.rememberChoice === 'function') window.AGSR.rememberChoice(pick.m.h, { size: v.size || '', ret: v.ret || '' });
        open = null;
        repaint(which);
      }));
      bindAdd();
    };
    paint();
    host.hidden = false;
    // the view counts only while the drawer is open (the cards also paint on page load, drawer closed), once per card
    // key per open; close() resets the keys. The key is the piece, not the variant: a size change is not a new view.
    const key = setHandle + ':' + pick.m.h + ':' + pieces;
    const agOpen = this.drawer && this.drawer.classList.contains('cart-drawer--open');
    this._agRowSeen = this._agRowSeen || {};
    if (agOpen && !this._agRowSeen[key]) { this._agRowSeen[key] = true; this._agTrack('ag_cart_set_view', { set: setHandle, slot: pick.m.type, handle: pick.m.h, variant: pick.v.id, price: pick.v.p, pieces }); }
    return host;
  }

  formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }

  async open() {
    console.log('CartDrawer.open() called');
    console.log('Drawer element:', this.drawer);
    console.log('Adding cart-drawer--open class');
    
    this.drawer.classList.add('cart-drawer--open');
    document.body.classList.add('cart-drawer-open');
    
    console.log('Classes added, drawer should be visible now');
    
    // Refresh cart data when opening
    try {
      const cart = await this.refreshCart();
      console.log('Cart refreshed on open, items:', cart?.items?.length || 0);
      
      // If cart has items, ensure all elements are properly displayed
      if (cart && cart.items.length > 0) {
        console.log('Cart has items, ensuring proper display');
        // Force a re-render to ensure all elements are visible
        setTimeout(() => {
          this.showCartItems(cart);
          this.updateTotals(cart);
        }, 100);
      }
    } catch (error) {
      console.error('Error refreshing cart on open:', error);
    }
    
    // Initialize payment buttons after cart is refreshed
    setTimeout(() => {
      this.initializePaymentButtons();
    }, 300);
    
    // Focus first focusable element
    const firstFocusable = this.drawer.querySelector('button, input, a');
    if (firstFocusable) {
      firstFocusable.focus();
    }
  }

  initializePaymentButtons() {
    console.log('Initializing payment buttons in cart drawer...');
    
    // First check if cart is empty - don't initialize if empty
    const cartContent = this.querySelector('.cart-drawer__content');
    const isEmpty = this.drawer.classList.contains('cart-drawer--empty') || 
                    !cartContent || 
                    cartContent.querySelector('.cart-drawer__empty');
    
    if (isEmpty) {
      console.log('Cart is empty, skipping payment button initialization');
      // Hide any existing payment buttons
      const paymentWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
      if (paymentWrapper) {
        paymentWrapper.style.display = 'none';
      }
      return;
    }
    
    const paymentWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
    if (!paymentWrapper) {
      console.log('No payment wrapper found in cart drawer');
      return;
    }
    
    // Ensure wrapper is visible only if cart has items
    paymentWrapper.style.display = 'block';
    paymentWrapper.style.opacity = '1';
    
    // Remove any skeleton loaders that might be stuck
    const skeletons = paymentWrapper.querySelectorAll('.shopify-payment-button__skeleton, .wallet-cart-button__skeleton');
    skeletons.forEach(skeleton => {
      skeleton.style.display = 'none';
      console.log('Removed cart drawer payment button skeleton');
    });
    
    // Hide skeleton loaders in shopify-accelerated-checkout-cart component
    const checkoutCart = paymentWrapper.querySelector('shopify-accelerated-checkout-cart');
    if (checkoutCart) {
      const walletSkeletons = checkoutCart.querySelectorAll('.wallet-cart-button__skeleton');
      walletSkeletons.forEach(skeleton => {
        skeleton.style.display = 'none';
      });
      
      // Ensure the component itself is visible
      checkoutCart.style.display = 'block';
    }
    
    // Initialize Shopify payment buttons if available
    if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) {
      try {
        console.log('Calling Shopify.PaymentButton.init() for cart drawer');
        Shopify.PaymentButton.init();
        console.log('Cart drawer payment buttons initialized');
      } catch (error) {
        console.error('Error initializing cart drawer payment buttons:', error);
      }
    } else {
      console.log('Shopify.PaymentButton not available, will try again...');
      // Try again after a delay
      setTimeout(() => this.initializePaymentButtons(), 500);
    }
  }

  close() {
    this._agRowSeen = null;
    console.log('CartDrawer.close() called');
    this.drawer.classList.remove('cart-drawer--open');
    document.body.classList.remove('cart-drawer-open');
    console.log('Cart drawer closed');
  }

  isOpen() {
    return this.drawer.classList.contains('cart-drawer--open');
  }

  connectedCallback() {
    // Called when the element is inserted into the DOM
    console.log('Cart drawer connected to DOM');
    
    // Initialize checkout buttons if cart has items and buttons are already rendered
    setTimeout(() => {
      const paymentWrapper = this.querySelector('.cart-drawer__dynamic-checkout');
      if (paymentWrapper && paymentWrapper.querySelector('shopify-accelerated-checkout-cart')) {
        // Check if cart has items
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            if (cart && cart.items.length > 0) {
              console.log('Initializing checkout buttons on connect (cart has items)');
              this.showDynamicCheckoutButtons();
              this.initializePaymentButtons();
            }
          })
          .catch(error => {
            console.error('Error checking cart on connect:', error);
          });
      }
    }, 100);
  }
}

customElements.define('cart-drawer', CartDrawer);

/* Cart links (Ansen 2026-10-18): a click on the photo or anywhere on a cart line, a "Complete the ... set" card or
   the chair card follows that card's own name link, so it opens the same product page (custom finish carried).
   Buttons, fields, links, the (i) of a Finish preview ID, the set's size list and the quantity / remove boxes (a near
   miss on a stepper stays in the cart) keep their own job; so does a click that ends a text selection. The nearest
   card wins: a set with one line carries its card inside that line. */
(function () {
  var CARD = '.cart-drawer__item, .ag-cart-set, .ag-cart-chair';
  var NAME = { 'cart-drawer__item': '.cart-drawer__item-link', 'ag-cart-set': '.ag-cart-set__title', 'ag-cart-chair': '.ag-cart-chair__title' };
  var KEEP = 'a, button, input, select, textarea, label, summary, [role="button"], [contenteditable], .ag-fp, .ag-cart-set__list, '
    + '.cart-drawer__item-quantity, .cart-drawer__item-remove, .ag-cart-chair__qty, [data-ag-no-card-link]';   /* a near miss on a stepper stays in the cart */
  function nameLink(t) {
    if (!t || !t.closest || t.closest(KEEP)) return null;
    var card = t.closest(CARD);
    if (!card || !card.closest('cart-drawer')) return null;
    var cls = card.classList.contains('ag-cart-set') ? 'ag-cart-set'
      : card.classList.contains('ag-cart-chair') ? 'ag-cart-chair' : 'cart-drawer__item';
    var a = null;
    card.querySelectorAll(NAME[cls]).forEach(function (x) { if (!a && x.closest(CARD) === card) a = x; });
    return a && a.href ? a : null;
  }
  function picking() {   /* someone selecting text is not a click on the card */
    var s = window.getSelection && window.getSelection();
    return !!(s && !s.isCollapsed && String(s).trim());
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || picking()) return;
    var a = nameLink(e.target);
    if (!a) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) { window.open(a.href, '_blank', 'noopener'); return; }
    a.click();
  });
  document.addEventListener('auxclick', function (e) {
    if (e.button !== 1) return;
    var a = nameLink(e.target);
    if (a) window.open(a.href, '_blank', 'noopener');
  });
})();

/* ag-cart-open (2026-10-19, marketing emails): Ansen 2026-10-19, "When you click Add to Cart, it shouldn't go to the
   cart page, but it should add it to the side cart." A link lands on any page with the piece in the cart and the cart
   drawer open, instead of on /cart:
     ?ag_add=VARIANT:QTY[,VARIANT:QTY...]  each variant NOT in the cart yet is added, all in one POST /cart/add.js
                                           (QTY 1-99, 1 when left out; up to 10 pieces; a bad id is skipped)
     ?ag_cart=open                         the drawer opens (CartDrawer.refreshCart() then open(), the same calls the
                                           product form makes in layout/theme.liquid); on its own it adds nothing
   Both come off the address bar first (history.replaceState; every other param and the #hash kept byte for byte), so
   a refresh never adds again, and a variant already in the cart is never added twice.
   Email links (theme-test/cart-open/README.md): /products/<handle>?variant=ID&ag_add=ID:1&ag_cart=open, and with a
   code /discount/CODE?redirect=%2Fproducts%2F<handle>&variant=ID&ag_add=ID%3A1&ag_cart=open (Shopify's discount
   redirect drops the query inside redirect= as soon as the outer link carries any other param, e.g. utm_*).
   Never throws, never holds the page up; window.__agCartOpen says what it did. */
(function () {
  var KEYS = { ag_add: 1, ag_cart: 1 };
  function ours(seg) {
    var k = seg.split('=')[0];
    try { k = decodeURIComponent(k.replace(/\+/g, ' ')); } catch (e) {}
    return !!KEYS[k];
  }
  function strip() {   /* take only our two params off the address bar; the rest stays exactly as it was */
    try {
      var q = window.location.search.replace(/^\?/, '');
      if (!q) return;
      var all = q.split('&');
      var kept = all.filter(function (s) { return s && !ours(s); });
      if (kept.length === all.filter(Boolean).length) return;
      history.replaceState(history.state, '', window.location.pathname + (kept.length ? '?' + kept.join('&') : '') + window.location.hash);
    } catch (e) {}
  }
  try {
    if (window.__agCartOpen) return;
    var p = new URLSearchParams(window.location.search);
    if (!p.has('ag_add') && !p.has('ag_cart')) return;
    var st = window.__agCartOpen = { want: [], added: [], skipped: [], opened: false, done: false };
    var openIt = String(p.get('ag_cart') || '').toLowerCase() === 'open';
    var seen = {};
    String(p.get('ag_add') || '').split(',').slice(0, 10).forEach(function (part) {
      var m = /^\s*(\d{1,16})(?::(\d{1,4}))?\s*$/.exec(part);
      if (!m) { if (part.trim()) st.skipped.push(part.trim()); return; }
      var qty = m[2] ? parseInt(m[2], 10) : 1;
      if (!(qty >= 1) || seen[m[1]]) { st.skipped.push(part.trim()); return; }
      seen[m[1]] = 1;
      st.want.push({ id: Number(m[1]), quantity: Math.min(qty, 99) });
    });
    strip();
    var getCart = function () {
      return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
    };
    var missing = function (cart, list) {   /* only what the cart does not hold yet, by variant */
      var have = {};
      ((cart && cart.items) || []).forEach(function (it) { have[it.variant_id] = 1; });
      return list.filter(function (w) { return !have[w.id]; });
    };
    var post = function (items) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }) });
    };
    var run = async function () {
      if (st.want.length) {
        try {
          var add = missing(await getCart(), st.want);
          st.skipped = st.skipped.concat(st.want.filter(function (w) { return add.indexOf(w) < 0; }).map(function (w) { return w.id + ' (in the cart)'; }));
          if (add.length) {
            var r = await post(add);
            if (r.ok) st.added = add.map(function (w) { return w.id; });
            else if (add.length > 1) {   /* one bad or sold-out id fails the whole add: re-read the cart, then one by one */
              var left = missing(await getCart(), add);
              for (var i = 0; i < left.length; i++) {
                try { if ((await post([left[i]])).ok) st.added.push(left[i].id); else st.skipped.push(left[i].id + ' (refused)'); } catch (e) {}
              }
            } else st.skipped.push(add[0].id + ' (refused)');
          }
        } catch (e) { st.error = String(e && e.message || e); }
      }
      try { if (window.customElements && customElements.whenDefined) await customElements.whenDefined('cart-drawer'); } catch (e) {}
      var drawer = document.querySelector('cart-drawer');
      if (drawer && (st.added.length || openIt)) {
        try { if (drawer.refreshCart) await drawer.refreshCart(); } catch (e) {}
        if (openIt && drawer.open) {
          try { await drawer.open(); st.opened = true; } catch (e) {}
        }
      }
      strip();   /* again, in case a page script wrote the old address back meanwhile */
    };
    run().catch(function () {}).then(function () { st.done = true; });
  } catch (e) {}
})();
